function PlanEE({ ...props }) {
	return (
		<g {...props} id="unit-ee">
			<g id="furniture">
				<polyline
					points="258.96 788.48 258.96 502.11 313.73 502.11 313.73 788.48 258.96 788.48"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="333.7 497.01 338.74 497.01 338.74 499.56 333.7 499.56 333.7 497.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="816.51"
					y1="405.82"
					x2="690.8"
					y2="405.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.51"
					y1="440.05"
					x2="808.98"
					y2="440.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.27"
					y1="440.05"
					x2="816.51"
					y2="440.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="816.51"
					y1="422.43"
					x2="816.51"
					y2="416.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="816.51"
					y1="413.67"
					x2="816.51"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="816.51"
					y1="408.1"
					x2="812.27"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.98"
					y1="408.1"
					x2="803.51"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="800.22"
					y1="408.1"
					x2="794.74"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.45"
					y1="408.1"
					x2="785.98"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.69"
					y1="408.1"
					x2="777.21"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.92"
					y1="408.1"
					x2="768.45"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.16"
					y1="408.1"
					x2="759.68"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.4"
					y1="408.1"
					x2="750.92"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.63"
					y1="408.1"
					x2="742.16"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.87"
					y1="408.1"
					x2="733.39"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.1"
					y1="408.1"
					x2="724.63"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.34"
					y1="408.1"
					x2="715.86"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.58"
					y1="408.1"
					x2="707.1"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.81"
					y1="408.1"
					x2="698.33"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.05"
					y1="408.1"
					x2="690.8"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.8"
					y1="408.1"
					x2="690.8"
					y2="413.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.8"
					y1="416.95"
					x2="690.8"
					y2="422.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.39"
					y1="405.82"
					x2="555.12"
					y2="405.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.39"
					y1="422.43"
					x2="679.39"
					y2="416.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.39"
					y1="413.67"
					x2="679.39"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.39"
					y1="408.1"
					x2="675.87"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="672.58"
					y1="408.1"
					x2="667.1"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.82"
					y1="408.1"
					x2="658.34"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.05"
					y1="408.1"
					x2="649.57"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.29"
					y1="408.1"
					x2="640.81"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="637.52"
					y1="408.1"
					x2="632.05"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="628.76"
					y1="408.1"
					x2="623.28"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620"
					y1="408.1"
					x2="614.52"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.23"
					y1="408.1"
					x2="605.75"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="602.47"
					y1="408.1"
					x2="596.99"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.7"
					y1="408.1"
					x2="588.23"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.94"
					y1="408.1"
					x2="579.46"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.18"
					y1="408.1"
					x2="570.7"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="567.41"
					y1="408.1"
					x2="561.93"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.65"
					y1="408.1"
					x2="555.12"
					y2="408.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.12"
					y1="408.1"
					x2="555.12"
					y2="413.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.12"
					y1="416.95"
					x2="555.12"
					y2="422.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.72"
					y1="800.79"
					x2="183.49"
					y2="800.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.72"
					y1="930.6"
					x2="217.72"
					y2="800.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.49"
					y1="800.79"
					x2="183.49"
					y2="802.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.49"
					y1="805.99"
					x2="183.49"
					y2="811.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.49"
					y1="814.76"
					x2="183.49"
					y2="820.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.49"
					y1="823.52"
					x2="183.49"
					y2="829"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.49"
					y1="832.28"
					x2="183.49"
					y2="837.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.49"
					y1="841.05"
					x2="183.49"
					y2="846.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.49"
					y1="849.81"
					x2="183.49"
					y2="855.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.49"
					y1="858.58"
					x2="183.49"
					y2="864.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.49"
					y1="867.34"
					x2="183.49"
					y2="872.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.49"
					y1="876.1"
					x2="183.49"
					y2="881.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.49"
					y1="884.87"
					x2="183.49"
					y2="890.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.11"
					y1="930.6"
					x2="206.58"
					y2="930.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.87"
					y1="930.6"
					x2="215.44"
					y2="930.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.44"
					y1="930.6"
					x2="215.44"
					y2="928.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.44"
					y1="925.4"
					x2="215.44"
					y2="919.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.44"
					y1="916.64"
					x2="215.44"
					y2="911.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.44"
					y1="907.87"
					x2="215.44"
					y2="902.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.44"
					y1="899.11"
					x2="215.44"
					y2="893.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.44"
					y1="890.35"
					x2="215.44"
					y2="884.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.44"
					y1="881.58"
					x2="215.44"
					y2="876.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.44"
					y1="872.82"
					x2="215.44"
					y2="867.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.44"
					y1="864.05"
					x2="215.44"
					y2="858.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.44"
					y1="855.29"
					x2="215.44"
					y2="849.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.44"
					y1="846.53"
					x2="215.44"
					y2="841.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.44"
					y1="837.76"
					x2="215.44"
					y2="832.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.44"
					y1="829"
					x2="215.44"
					y2="823.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.44"
					y1="820.23"
					x2="215.44"
					y2="814.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.44"
					y1="811.47"
					x2="215.44"
					y2="805.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.44"
					y1="802.71"
					x2="215.44"
					y2="800.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.44"
					y1="800.79"
					x2="209.87"
					y2="800.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.58"
					y1="800.79"
					x2="201.11"
					y2="800.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.82"
					y1="800.79"
					x2="192.34"
					y2="800.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.05"
					y1="800.79"
					x2="183.49"
					y2="800.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="587.5 604.93 587.5 661.32 531.11 661.32 531.11 604.93 587.5 604.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="301.28 53.67 301.28 58.61 339.5 58.61 339.5 53.67 301.28 53.67"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="341.3 53.22 299.48 53.22 299.48 53.67 341.3 53.67 341.3 53.22"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="341.3"
					y1="53.67"
					x2="341.3"
					y2="53.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.48"
					y1="53.67"
					x2="341.3"
					y2="53.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.48"
					y1="53.22"
					x2="299.48"
					y2="53.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.3"
					y1="53.22"
					x2="299.48"
					y2="53.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="301.28"
					y1="58.61"
					x2="339.5"
					y2="58.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.5"
					y1="53.67"
					x2="301.28"
					y2="53.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="297.24 58.61 301.28 58.61 301.28 53.67 297.24 53.67 297.24 58.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="297.24"
					y1="53.67"
					x2="297.24"
					y2="58.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="301.28"
					y1="53.67"
					x2="297.24"
					y2="53.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="301.28"
					y1="58.61"
					x2="301.28"
					y2="53.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.24"
					y1="58.61"
					x2="301.28"
					y2="58.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="343.54 53.67 339.5 53.67 339.5 58.61 343.54 58.61 343.54 53.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="343.54"
					y1="58.61"
					x2="343.54"
					y2="53.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.5"
					y1="58.61"
					x2="343.54"
					y2="58.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.5"
					y1="53.67"
					x2="339.5"
					y2="58.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.54"
					y1="53.67"
					x2="339.5"
					y2="53.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="301.28"
					y1="54.56"
					x2="339.5"
					y2="54.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="295.44 58.16 297.24 58.16 297.24 53.67 299.48 53.67 299.48 53.22 295.44 53.22 295.44 58.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="295.44"
					y1="53.22"
					x2="295.44"
					y2="58.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.48"
					y1="53.22"
					x2="295.44"
					y2="53.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.48"
					y1="53.67"
					x2="299.48"
					y2="53.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.24"
					y1="53.67"
					x2="299.48"
					y2="53.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.24"
					y1="58.16"
					x2="297.24"
					y2="53.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="295.44"
					y1="58.16"
					x2="297.24"
					y2="58.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="345.34 53.22 341.3 53.22 341.3 53.67 343.54 53.67 343.54 58.16 345.34 58.16 345.34 53.22"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="345.34"
					y1="58.16"
					x2="345.34"
					y2="53.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.54"
					y1="58.16"
					x2="345.34"
					y2="58.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.54"
					y1="53.67"
					x2="343.54"
					y2="58.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.3"
					y1="53.67"
					x2="343.54"
					y2="53.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.3"
					y1="53.22"
					x2="341.3"
					y2="53.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.34"
					y1="53.22"
					x2="341.3"
					y2="53.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="347.62 54.56 347.62 56.85 468.09 56.85 468.09 54.56 347.62 54.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="468.09"
					y1="54.56"
					x2="347.62"
					y2="54.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.09"
					y1="56.85"
					x2="468.09"
					y2="54.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.62"
					y1="56.85"
					x2="468.09"
					y2="56.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.62"
					y1="54.56"
					x2="347.62"
					y2="56.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="295.44 54.56 295.44 68.26 290.88 68.26 290.88 54.56 295.44 54.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="295.44"
					y1="68.26"
					x2="295.44"
					y2="54.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.88"
					y1="68.26"
					x2="295.44"
					y2="68.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.88"
					y1="54.56"
					x2="290.88"
					y2="68.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="295.44"
					y1="54.56"
					x2="290.88"
					y2="54.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="349.9 54.56 349.9 68.26 345.34 68.26 345.34 54.56 349.9 54.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="349.9"
					y1="68.26"
					x2="349.9"
					y2="54.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.34"
					y1="68.26"
					x2="349.9"
					y2="68.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.34"
					y1="54.56"
					x2="345.34"
					y2="68.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.9"
					y1="54.56"
					x2="345.34"
					y2="54.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="470.38 54.56 470.38 68.26 465.81 68.26 465.81 54.56 470.38 54.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="470.38"
					y1="68.26"
					x2="470.38"
					y2="54.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.81"
					y1="68.26"
					x2="470.38"
					y2="68.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.81"
					y1="54.56"
					x2="465.81"
					y2="68.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="470.38"
					y1="54.56"
					x2="465.81"
					y2="54.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="616.97 53.67 616.97 58.61 655.19 58.61 655.19 53.67 616.97 53.67"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="656.98 53.22 615.17 53.22 615.17 53.67 656.98 53.67 656.98 53.22"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="656.98"
					y1="53.67"
					x2="656.98"
					y2="53.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="615.17"
					y1="53.67"
					x2="656.98"
					y2="53.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="615.17"
					y1="53.22"
					x2="615.17"
					y2="53.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.98"
					y1="53.22"
					x2="615.17"
					y2="53.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="616.97"
					y1="58.61"
					x2="655.19"
					y2="58.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.19"
					y1="53.67"
					x2="616.97"
					y2="53.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="612.93 58.61 616.97 58.61 616.97 53.67 612.93 53.67 612.93 58.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="612.93"
					y1="53.67"
					x2="612.93"
					y2="58.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="616.97"
					y1="53.67"
					x2="612.93"
					y2="53.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="616.97"
					y1="58.61"
					x2="616.97"
					y2="53.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="612.93"
					y1="58.61"
					x2="616.97"
					y2="58.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="659.23 53.67 655.19 53.67 655.19 58.61 659.23 58.61 659.23 53.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="659.23"
					y1="58.61"
					x2="659.23"
					y2="53.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.19"
					y1="58.61"
					x2="659.23"
					y2="58.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.19"
					y1="53.67"
					x2="655.19"
					y2="58.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.23"
					y1="53.67"
					x2="655.19"
					y2="53.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="616.97"
					y1="54.56"
					x2="655.19"
					y2="54.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="611.13 58.16 612.93 58.16 612.93 53.67 615.17 53.67 615.17 53.22 611.13 53.22 611.13 58.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="611.13"
					y1="53.22"
					x2="611.13"
					y2="58.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="615.17"
					y1="53.22"
					x2="611.13"
					y2="53.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="615.17"
					y1="53.67"
					x2="615.17"
					y2="53.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="612.93"
					y1="53.67"
					x2="615.17"
					y2="53.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="612.93"
					y1="58.16"
					x2="612.93"
					y2="53.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.13"
					y1="58.16"
					x2="612.93"
					y2="58.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="661.03 53.22 656.98 53.22 656.98 53.67 659.23 53.67 659.23 58.16 661.03 58.16 661.03 53.22"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="661.03"
					y1="58.16"
					x2="661.03"
					y2="53.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.23"
					y1="58.16"
					x2="661.03"
					y2="58.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.23"
					y1="53.67"
					x2="659.23"
					y2="58.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.98"
					y1="53.67"
					x2="659.23"
					y2="53.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.98"
					y1="53.22"
					x2="656.98"
					y2="53.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="661.03"
					y1="53.22"
					x2="656.98"
					y2="53.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="663.31 54.56 663.31 56.85 756.72 56.85 756.72 54.56 663.31 54.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="756.72"
					y1="54.56"
					x2="663.31"
					y2="54.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.72"
					y1="56.85"
					x2="756.72"
					y2="54.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.31"
					y1="56.85"
					x2="756.72"
					y2="56.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.31"
					y1="54.56"
					x2="663.31"
					y2="56.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="611.13 54.56 611.13 68.26 606.57 68.26 606.57 54.56 611.13 54.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="611.13"
					y1="68.26"
					x2="611.13"
					y2="54.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.57"
					y1="68.26"
					x2="611.13"
					y2="68.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.57"
					y1="54.56"
					x2="606.57"
					y2="68.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.13"
					y1="54.56"
					x2="606.57"
					y2="54.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="665.59 54.56 665.59 68.26 661.03 68.26 661.03 54.56 665.59 54.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="665.59"
					y1="68.26"
					x2="665.59"
					y2="54.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="661.03"
					y1="68.26"
					x2="665.59"
					y2="68.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="661.03"
					y1="54.56"
					x2="661.03"
					y2="68.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.59"
					y1="54.56"
					x2="661.03"
					y2="54.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="759.01 54.56 759.01 68.26 754.44 68.26 754.44 54.56 759.01 54.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="759.01"
					y1="68.26"
					x2="759.01"
					y2="54.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.44"
					y1="68.26"
					x2="759.01"
					y2="68.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.44"
					y1="54.56"
					x2="754.44"
					y2="68.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.01"
					y1="54.56"
					x2="754.44"
					y2="54.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.57"
					y1="670.95"
					x2="638.11"
					y2="670.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="759.01"
					y1="50"
					x2="759.01"
					y2="68.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="309.41"
					y1="948.86"
					x2="305.99"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="309.41"
					y1="930.6"
					x2="305.99"
					y2="930.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="309.41"
					y1="930.6"
					x2="309.41"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="310.55 950 310.55 948.86 305.99 948.86 305.99 950 310.55 950"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="310.55 930.6 310.55 929.46 305.99 929.46 305.99 930.6 310.55 930.6"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="310.55"
					y1="950"
					x2="305.99"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.99"
					y1="950"
					x2="305.99"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.99"
					y1="948.86"
					x2="310.55"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="310.55"
					y1="948.86"
					x2="310.55"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="310.55"
					y1="930.6"
					x2="305.99"
					y2="930.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.99"
					y1="930.6"
					x2="305.99"
					y2="929.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.99"
					y1="929.46"
					x2="310.55"
					y2="929.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="310.55"
					y1="929.46"
					x2="310.55"
					y2="930.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="311.69 948.86 311.69 930.6 309.98 930.6 309.98 948.86 311.69 948.86"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="335.76 872.5 332.93 875.33 391.03 933.42 393.85 930.6 335.76 872.5"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="309.98"
					y1="930.6"
					x2="309.41"
					y2="930.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.98"
					y1="948.86"
					x2="309.41"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.41"
					y1="930.6"
					x2="309.41"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.69"
					y1="948.86"
					x2="311.69"
					y2="930.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.69"
					y1="930.6"
					x2="309.98"
					y2="930.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.98"
					y1="930.6"
					x2="309.98"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.98"
					y1="948.86"
					x2="311.69"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.85"
					y1="930.6"
					x2="393.85"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.76"
					y1="872.5"
					x2="332.93"
					y2="875.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.93"
					y1="875.33"
					x2="391.03"
					y2="933.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.03"
					y1="933.42"
					x2="393.85"
					y2="930.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.85"
					y1="930.6"
					x2="335.76"
					y2="872.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.41"
					y1="930.6"
					x2="309.41"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="309.41"
					y1="930.6"
					x2="309.41"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="309.41"
					y1="930.6"
					x2="305.99"
					y2="930.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="309.41"
					y1="930.6"
					x2="305.99"
					y2="930.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="309.41"
					y1="948.86"
					x2="305.99"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="309.41"
					y1="948.86"
					x2="305.99"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="247.54"
					y1="869.21"
					x2="247.54"
					y2="872.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="258.96"
					y1="869.21"
					x2="258.96"
					y2="872.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="258.96"
					y1="869.21"
					x2="247.54"
					y2="869.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="258.96"
					y1="805.31"
					x2="258.96"
					y2="801.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="258.96"
					y1="805.31"
					x2="258.96"
					y2="800.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="247.54 868.07 246.4 868.07 246.4 872.64 247.54 872.64 247.54 868.07"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="258.96 806.45 260.1 806.45 260.1 801.88 258.96 801.88 258.96 806.45"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="260.1 868.07 258.96 868.07 258.96 872.64 260.1 872.64 260.1 868.07"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="247.54"
					y1="868.07"
					x2="247.54"
					y2="872.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.54"
					y1="872.64"
					x2="246.4"
					y2="872.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.4"
					y1="872.64"
					x2="246.4"
					y2="868.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.4"
					y1="868.07"
					x2="247.54"
					y2="868.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.96"
					y1="806.45"
					x2="258.96"
					y2="801.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.96"
					y1="801.88"
					x2="260.1"
					y2="801.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.1"
					y1="801.88"
					x2="260.1"
					y2="806.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.1"
					y1="806.45"
					x2="258.96"
					y2="806.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.1"
					y1="868.07"
					x2="260.1"
					y2="872.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.1"
					y1="872.64"
					x2="258.96"
					y2="872.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.96"
					y1="872.64"
					x2="258.96"
					y2="868.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.96"
					y1="868.07"
					x2="260.1"
					y2="868.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="247.54 868.64 258.96 868.64 258.96 866.93 247.54 866.93 247.54 868.64"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="300.92 824.97 298.09 822.15 256.13 864.11 258.96 866.93 300.92 824.97"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="258.96"
					y1="805.88"
					x2="258.96"
					y2="805.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.96"
					y1="868.64"
					x2="258.96"
					y2="869.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.54"
					y1="868.64"
					x2="247.54"
					y2="869.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.96"
					y1="869.21"
					x2="247.54"
					y2="869.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.96"
					y1="807.59"
					x2="258.96"
					y2="805.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.54"
					y1="868.64"
					x2="258.96"
					y2="868.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.96"
					y1="868.64"
					x2="258.96"
					y2="866.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.96"
					y1="866.93"
					x2="247.54"
					y2="866.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.54"
					y1="866.93"
					x2="247.54"
					y2="868.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.92"
					y1="824.97"
					x2="298.09"
					y2="822.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="298.09"
					y1="822.15"
					x2="256.13"
					y2="864.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.13"
					y1="864.11"
					x2="258.96"
					y2="866.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.96"
					y1="866.93"
					x2="300.92"
					y2="824.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.96"
					y1="805.31"
					x2="258.96"
					y2="801.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="258.96"
					y1="805.31"
					x2="258.96"
					y2="801.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="258.96"
					y1="869.21"
					x2="247.54"
					y2="869.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="258.96"
					y1="869.21"
					x2="247.54"
					y2="869.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="258.96"
					y1="869.21"
					x2="258.96"
					y2="872.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="258.96"
					y1="869.21"
					x2="258.96"
					y2="872.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="247.54"
					y1="869.21"
					x2="247.54"
					y2="872.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="247.54"
					y1="869.21"
					x2="247.54"
					y2="872.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="588.01"
					y1="597.29"
					x2="591.43"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="588.01"
					y1="585.87"
					x2="591.43"
					y2="585.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="588.01"
					y1="585.87"
					x2="588.01"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="528.67"
					y1="597.29"
					x2="525.25"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="528.67"
					y1="585.87"
					x2="525.25"
					y2="585.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="528.67"
					y1="585.87"
					x2="528.67"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="529.81 598.43 529.81 597.29 525.25 597.29 525.25 598.43 529.81 598.43"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="586.87 597.29 586.87 598.43 591.43 598.43 591.43 597.29 586.87 597.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="529.81 585.87 529.81 584.73 525.25 584.73 525.25 585.87 529.81 585.87"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="586.87 584.73 586.87 585.87 591.43 585.87 591.43 584.73 586.87 584.73"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="529.81"
					y1="598.43"
					x2="525.25"
					y2="598.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.25"
					y1="598.43"
					x2="525.25"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.25"
					y1="597.29"
					x2="529.81"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.81"
					y1="597.29"
					x2="529.81"
					y2="598.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.87"
					y1="597.29"
					x2="591.43"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.43"
					y1="597.29"
					x2="591.43"
					y2="598.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.43"
					y1="598.43"
					x2="586.87"
					y2="598.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.87"
					y1="598.43"
					x2="586.87"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.81"
					y1="585.87"
					x2="525.25"
					y2="585.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.25"
					y1="585.87"
					x2="525.25"
					y2="584.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.25"
					y1="584.73"
					x2="529.81"
					y2="584.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.81"
					y1="584.73"
					x2="529.81"
					y2="585.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.87"
					y1="584.73"
					x2="591.43"
					y2="584.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.43"
					y1="584.73"
					x2="591.43"
					y2="585.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.43"
					y1="585.87"
					x2="586.87"
					y2="585.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.87"
					y1="585.87"
					x2="586.87"
					y2="584.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="530.95 597.29 530.95 585.87 529.24 585.87 529.24 597.29 530.95 597.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="587.44 597.29 587.44 585.87 585.73 585.87 585.73 597.29 587.44 597.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="547 547.14 544.17 549.97 582.9 588.7 585.73 585.87 547 547.14"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="529.24"
					y1="585.87"
					x2="528.67"
					y2="585.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.24"
					y1="597.29"
					x2="528.67"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.67"
					y1="585.87"
					x2="528.67"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.44"
					y1="585.87"
					x2="588.01"
					y2="585.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.44"
					y1="597.29"
					x2="588.01"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="588.01"
					y1="585.87"
					x2="588.01"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.95"
					y1="597.29"
					x2="530.95"
					y2="585.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.95"
					y1="585.87"
					x2="529.24"
					y2="585.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.24"
					y1="585.87"
					x2="529.24"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.24"
					y1="597.29"
					x2="530.95"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.44"
					y1="597.29"
					x2="587.44"
					y2="585.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.44"
					y1="585.87"
					x2="585.73"
					y2="585.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="585.73"
					y1="585.87"
					x2="585.73"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="585.73"
					y1="597.29"
					x2="587.44"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547"
					y1="547.14"
					x2="544.17"
					y2="549.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.17"
					y1="549.97"
					x2="582.9"
					y2="588.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.9"
					y1="588.7"
					x2="585.73"
					y2="585.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="585.73"
					y1="585.87"
					x2="547"
					y2="547.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.67"
					y1="585.87"
					x2="528.67"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="528.67"
					y1="585.87"
					x2="528.67"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="528.67"
					y1="585.87"
					x2="525.25"
					y2="585.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="528.67"
					y1="585.87"
					x2="525.25"
					y2="585.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="528.67"
					y1="597.29"
					x2="525.25"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="528.67"
					y1="597.29"
					x2="525.25"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="588.01"
					y1="585.87"
					x2="588.01"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="588.01"
					y1="585.87"
					x2="588.01"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="588.01"
					y1="585.87"
					x2="591.43"
					y2="585.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="588.01"
					y1="585.87"
					x2="591.43"
					y2="585.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="588.01"
					y1="597.29"
					x2="591.43"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="588.01"
					y1="597.29"
					x2="591.43"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="638.11"
					y1="585.87"
					x2="638.11"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="638.11"
					y1="670.95"
					x2="638.11"
					y2="597.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="626.7"
					y1="462.62"
					x2="626.7"
					y2="459.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="638.11"
					y1="462.62"
					x2="638.11"
					y2="459.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="638.11"
					y1="462.62"
					x2="626.7"
					y2="462.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="626.7"
					y1="549.35"
					x2="626.7"
					y2="552.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="638.11"
					y1="549.35"
					x2="638.11"
					y2="552.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="638.11"
					y1="549.35"
					x2="626.7"
					y2="549.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="638.11"
					y1="585.87"
					x2="638.11"
					y2="549.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="625.56 548.21 625.56 552.78 626.7 552.78 626.7 548.21 625.56 548.21"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="626.7 463.77 626.7 459.2 625.56 459.2 625.56 463.77 626.7 463.77"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="638.11 548.21 638.11 552.78 639.25 552.78 639.25 548.21 638.11 548.21"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="639.25 463.77 639.25 459.2 638.11 459.2 638.11 463.77 639.25 463.77"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="625.56"
					y1="548.21"
					x2="625.56"
					y2="552.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="625.56"
					y1="552.78"
					x2="626.7"
					y2="552.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="626.7"
					y1="552.78"
					x2="626.7"
					y2="548.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="626.7"
					y1="548.21"
					x2="625.56"
					y2="548.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="626.7"
					y1="463.77"
					x2="626.7"
					y2="459.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="626.7"
					y1="459.2"
					x2="625.56"
					y2="459.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="625.56"
					y1="459.2"
					x2="625.56"
					y2="463.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="625.56"
					y1="463.77"
					x2="626.7"
					y2="463.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.11"
					y1="548.21"
					x2="638.11"
					y2="552.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.11"
					y1="552.78"
					x2="639.25"
					y2="552.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="639.25"
					y1="552.78"
					x2="639.25"
					y2="548.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="639.25"
					y1="548.21"
					x2="638.11"
					y2="548.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="639.25"
					y1="463.77"
					x2="639.25"
					y2="459.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="639.25"
					y1="459.2"
					x2="638.11"
					y2="459.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.11"
					y1="459.2"
					x2="638.11"
					y2="463.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.11"
					y1="463.77"
					x2="639.25"
					y2="463.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="626.7 547.07 626.7 548.78 638.11 548.78 638.11 547.07 626.7 547.07"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="626.7 463.2 626.7 464.91 638.11 464.91 638.11 463.2 626.7 463.2"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="696.21 523.01 638.11 464.91 635.28 467.73 693.38 525.83 696.21 523.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="638.11"
					y1="548.78"
					x2="638.11"
					y2="549.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="626.7"
					y1="548.78"
					x2="626.7"
					y2="549.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.11"
					y1="549.35"
					x2="626.7"
					y2="549.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.11"
					y1="463.2"
					x2="638.11"
					y2="462.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="626.7"
					y1="463.2"
					x2="626.7"
					y2="462.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.11"
					y1="462.62"
					x2="626.7"
					y2="462.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="626.7"
					y1="547.07"
					x2="638.11"
					y2="547.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.11"
					y1="547.07"
					x2="638.11"
					y2="548.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.11"
					y1="548.78"
					x2="626.7"
					y2="548.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="626.7"
					y1="548.78"
					x2="626.7"
					y2="547.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="626.7"
					y1="463.2"
					x2="638.11"
					y2="463.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.11"
					y1="463.2"
					x2="638.11"
					y2="464.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.11"
					y1="464.91"
					x2="626.7"
					y2="464.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="626.7"
					y1="464.91"
					x2="626.7"
					y2="463.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.21"
					y1="523.01"
					x2="693.38"
					y2="525.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.38"
					y1="525.83"
					x2="635.28"
					y2="467.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="635.28"
					y1="467.73"
					x2="638.11"
					y2="464.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.11"
					y1="464.91"
					x2="696.21"
					y2="523.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.11"
					y1="549.35"
					x2="626.7"
					y2="549.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="638.11"
					y1="549.35"
					x2="626.7"
					y2="549.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="638.11"
					y1="549.35"
					x2="638.11"
					y2="552.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="638.11"
					y1="549.35"
					x2="638.11"
					y2="552.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="626.7"
					y1="549.35"
					x2="626.7"
					y2="552.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="626.7"
					y1="549.35"
					x2="626.7"
					y2="552.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="638.11"
					y1="462.62"
					x2="626.7"
					y2="462.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="638.11"
					y1="462.62"
					x2="626.7"
					y2="462.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="638.11"
					y1="462.62"
					x2="638.11"
					y2="459.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="638.11"
					y1="462.62"
					x2="638.11"
					y2="459.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="626.7"
					y1="462.62"
					x2="626.7"
					y2="459.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="626.7"
					y1="462.62"
					x2="626.7"
					y2="459.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="543.71"
					y1="372.49"
					x2="543.71"
					y2="375.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="555.12"
					y1="372.49"
					x2="555.12"
					y2="375.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="555.12"
					y1="372.49"
					x2="543.71"
					y2="372.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="543.71"
					y1="285.76"
					x2="543.71"
					y2="282.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="555.12"
					y1="285.76"
					x2="555.12"
					y2="282.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="555.12"
					y1="285.76"
					x2="543.71"
					y2="285.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="555.12"
					y1="378.41"
					x2="555.12"
					y2="372.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="542.57 286.9 543.71 286.9 543.71 282.34 542.57 282.34 542.57 286.9"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="543.71 371.35 542.57 371.35 542.57 375.91 543.71 375.91 543.71 371.35"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="555.12 286.9 556.26 286.9 556.26 282.34 555.12 282.34 555.12 286.9"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="556.26 371.35 555.12 371.35 555.12 375.91 556.26 375.91 556.26 371.35"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="542.57"
					y1="286.9"
					x2="542.57"
					y2="282.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.57"
					y1="282.34"
					x2="543.71"
					y2="282.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.71"
					y1="282.34"
					x2="543.71"
					y2="286.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.71"
					y1="286.9"
					x2="542.57"
					y2="286.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.71"
					y1="371.35"
					x2="543.71"
					y2="375.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.71"
					y1="375.91"
					x2="542.57"
					y2="375.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.57"
					y1="375.91"
					x2="542.57"
					y2="371.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.57"
					y1="371.35"
					x2="543.71"
					y2="371.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.12"
					y1="286.9"
					x2="555.12"
					y2="282.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.12"
					y1="282.34"
					x2="556.26"
					y2="282.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.26"
					y1="282.34"
					x2="556.26"
					y2="286.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.26"
					y1="286.9"
					x2="555.12"
					y2="286.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.26"
					y1="371.35"
					x2="556.26"
					y2="375.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.26"
					y1="375.91"
					x2="555.12"
					y2="375.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.12"
					y1="375.91"
					x2="555.12"
					y2="371.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.12"
					y1="371.35"
					x2="556.26"
					y2="371.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="543.71 288.04 555.12 288.04 555.12 286.33 543.71 286.33 543.71 288.04"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="543.71 371.92 555.12 371.92 555.12 370.21 543.71 370.21 543.71 371.92"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="613.22 312.11 610.4 309.28 552.3 367.38 555.12 370.21 613.22 312.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="555.12"
					y1="286.33"
					x2="555.12"
					y2="285.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.71"
					y1="286.33"
					x2="543.71"
					y2="285.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.12"
					y1="285.76"
					x2="543.71"
					y2="285.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.12"
					y1="371.92"
					x2="555.12"
					y2="372.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.71"
					y1="371.92"
					x2="543.71"
					y2="372.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.12"
					y1="372.49"
					x2="543.71"
					y2="372.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.71"
					y1="288.04"
					x2="555.12"
					y2="288.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.12"
					y1="288.04"
					x2="555.12"
					y2="286.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.12"
					y1="286.33"
					x2="543.71"
					y2="286.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.71"
					y1="286.33"
					x2="543.71"
					y2="288.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.71"
					y1="371.92"
					x2="555.12"
					y2="371.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.12"
					y1="371.92"
					x2="555.12"
					y2="370.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.12"
					y1="370.21"
					x2="543.71"
					y2="370.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.71"
					y1="370.21"
					x2="543.71"
					y2="371.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.22"
					y1="312.11"
					x2="610.4"
					y2="309.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.4"
					y1="309.28"
					x2="552.3"
					y2="367.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.3"
					y1="367.38"
					x2="555.12"
					y2="370.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.12"
					y1="370.21"
					x2="613.22"
					y2="312.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.12"
					y1="285.76"
					x2="543.71"
					y2="285.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="555.12"
					y1="285.76"
					x2="543.71"
					y2="285.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="555.12"
					y1="285.76"
					x2="555.12"
					y2="282.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="555.12"
					y1="285.76"
					x2="555.12"
					y2="282.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="543.71"
					y1="285.76"
					x2="543.71"
					y2="282.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="543.71"
					y1="285.76"
					x2="543.71"
					y2="282.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="555.12"
					y1="372.49"
					x2="543.71"
					y2="372.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="555.12"
					y1="372.49"
					x2="543.71"
					y2="372.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="555.12"
					y1="372.49"
					x2="555.12"
					y2="375.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="555.12"
					y1="372.49"
					x2="555.12"
					y2="375.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="543.71"
					y1="372.49"
					x2="543.71"
					y2="375.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="543.71"
					y1="372.49"
					x2="543.71"
					y2="375.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="808.22"
					y1="389.83"
					x2="811.07"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="808.22"
					y1="387.54"
					x2="808.22"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="808.22"
					y1="378.41"
					x2="811.07"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="808.22"
					y1="378.41"
					x2="808.22"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="697.53"
					y1="389.83"
					x2="694.68"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="697.53"
					y1="387.54"
					x2="697.53"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="697.53"
					y1="378.41"
					x2="694.68"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="697.53"
					y1="378.41"
					x2="697.53"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="561.1"
					y1="389.83"
					x2="558.25"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="561.1"
					y1="387.54"
					x2="561.1"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="561.1"
					y1="378.41"
					x2="558.25"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="561.1"
					y1="378.41"
					x2="561.1"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="671.79"
					y1="389.83"
					x2="674.65"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="671.79"
					y1="387.54"
					x2="671.79"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="671.79"
					y1="378.41"
					x2="674.65"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="671.79"
					y1="378.41"
					x2="671.79"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="555.12"
					y1="389.83"
					x2="561.1"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="671.79"
					y1="389.83"
					x2="679.39"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="561.1"
					y1="378.41"
					x2="555.12"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="699.24 387.54 698.1 387.54 698.1 389.83 699.24 389.83 699.24 387.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="699.24 390.97 699.24 389.83 694.68 389.83 694.68 390.97 699.24 390.97"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="807.65 387.54 806.51 387.54 806.51 389.83 807.65 389.83 807.65 387.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="806.51 389.83 806.51 390.97 811.07 390.97 811.07 389.83 806.51 389.83"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="699.24 378.41 699.24 375.56 694.68 375.56 694.68 378.41 699.24 378.41"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="806.51 375.56 806.51 378.41 811.07 378.41 811.07 375.56 806.51 375.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="699.24"
					y1="387.54"
					x2="699.24"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.24"
					y1="389.83"
					x2="698.1"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.1"
					y1="389.83"
					x2="698.1"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.1"
					y1="387.54"
					x2="699.24"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.24"
					y1="390.97"
					x2="694.68"
					y2="390.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.68"
					y1="390.97"
					x2="694.68"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.68"
					y1="389.83"
					x2="699.24"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.24"
					y1="389.83"
					x2="699.24"
					y2="390.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.65"
					y1="387.54"
					x2="807.65"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.65"
					y1="389.83"
					x2="806.51"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.51"
					y1="389.83"
					x2="806.51"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.51"
					y1="387.54"
					x2="807.65"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.51"
					y1="389.83"
					x2="811.07"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.07"
					y1="389.83"
					x2="811.07"
					y2="390.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.07"
					y1="390.97"
					x2="806.51"
					y2="390.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.51"
					y1="390.97"
					x2="806.51"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.24"
					y1="378.41"
					x2="694.68"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.68"
					y1="378.41"
					x2="694.68"
					y2="375.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.68"
					y1="375.56"
					x2="699.24"
					y2="375.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.24"
					y1="375.56"
					x2="699.24"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.51"
					y1="375.56"
					x2="811.07"
					y2="375.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.07"
					y1="375.56"
					x2="811.07"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.07"
					y1="378.41"
					x2="806.51"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.51"
					y1="378.41"
					x2="806.51"
					y2="375.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="702.66 378.41 698.1 378.41 698.1 387.54 702.66 387.54 702.66 378.41"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="807.65 378.41 803.08 378.41 803.08 387.54 807.65 387.54 807.65 378.41"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="750.59 387.54 803.08 387.54 803.08 383.55 750.59 383.55 750.59 387.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="730.05 383.55 782.54 383.55 782.54 379.56 730.05 379.56 730.05 383.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="698.1"
					y1="387.54"
					x2="697.53"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.1"
					y1="378.41"
					x2="697.53"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.53"
					y1="387.54"
					x2="697.53"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.65"
					y1="387.54"
					x2="808.22"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.65"
					y1="378.41"
					x2="808.22"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.22"
					y1="387.54"
					x2="808.22"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="702.66"
					y1="378.41"
					x2="702.66"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="702.66"
					y1="387.54"
					x2="698.1"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.1"
					y1="387.54"
					x2="698.1"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.1"
					y1="378.41"
					x2="702.66"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.65"
					y1="378.41"
					x2="807.65"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.65"
					y1="387.54"
					x2="803.08"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.08"
					y1="387.54"
					x2="803.08"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.08"
					y1="378.41"
					x2="807.65"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.59"
					y1="387.54"
					x2="750.59"
					y2="383.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.59"
					y1="383.55"
					x2="803.08"
					y2="383.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.08"
					y1="383.55"
					x2="803.08"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.08"
					y1="387.54"
					x2="750.59"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.05"
					y1="383.55"
					x2="730.05"
					y2="379.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.05"
					y1="379.56"
					x2="782.54"
					y2="379.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.54"
					y1="379.56"
					x2="782.54"
					y2="383.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.54"
					y1="383.55"
					x2="730.05"
					y2="383.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.53"
					y1="378.41"
					x2="697.53"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="697.53"
					y1="378.41"
					x2="697.53"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="697.53"
					y1="387.54"
					x2="697.53"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="697.53"
					y1="378.41"
					x2="694.68"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="697.53"
					y1="387.54"
					x2="697.53"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="697.53"
					y1="389.83"
					x2="694.68"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="697.53"
					y1="389.83"
					x2="694.68"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="808.22"
					y1="378.41"
					x2="808.22"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="808.22"
					y1="378.41"
					x2="808.22"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="808.22"
					y1="387.54"
					x2="808.22"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="808.22"
					y1="378.41"
					x2="811.07"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="808.22"
					y1="387.54"
					x2="808.22"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="808.22"
					y1="389.83"
					x2="811.07"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="808.22"
					y1="389.83"
					x2="811.07"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="670.08 387.54 670.08 389.83 671.22 389.83 671.22 387.54 670.08 387.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="670.08 390.97 674.65 390.97 674.65 389.83 670.08 389.83 670.08 390.97"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="561.67 387.54 561.67 389.83 562.81 389.83 562.81 387.54 561.67 387.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="562.81 389.83 558.25 389.83 558.25 390.97 562.81 390.97 562.81 389.83"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="670.08 378.41 674.65 378.41 674.65 375.56 670.08 375.56 670.08 378.41"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="562.81 375.56 558.25 375.56 558.25 378.41 562.81 378.41 562.81 375.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="670.08"
					y1="387.54"
					x2="670.08"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.08"
					y1="389.83"
					x2="671.22"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.22"
					y1="389.83"
					x2="671.22"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.22"
					y1="387.54"
					x2="670.08"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.08"
					y1="390.97"
					x2="674.65"
					y2="390.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.65"
					y1="390.97"
					x2="674.65"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.65"
					y1="389.83"
					x2="670.08"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.08"
					y1="389.83"
					x2="670.08"
					y2="390.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.67"
					y1="387.54"
					x2="561.67"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.67"
					y1="389.83"
					x2="562.81"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.81"
					y1="389.83"
					x2="562.81"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.81"
					y1="387.54"
					x2="561.67"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.81"
					y1="389.83"
					x2="558.25"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.25"
					y1="389.83"
					x2="558.25"
					y2="390.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.25"
					y1="390.97"
					x2="562.81"
					y2="390.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.81"
					y1="390.97"
					x2="562.81"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.08"
					y1="378.41"
					x2="674.65"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.65"
					y1="378.41"
					x2="674.65"
					y2="375.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.65"
					y1="375.56"
					x2="670.08"
					y2="375.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.08"
					y1="375.56"
					x2="670.08"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.81"
					y1="375.56"
					x2="558.25"
					y2="375.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.25"
					y1="375.56"
					x2="558.25"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.25"
					y1="378.41"
					x2="562.81"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.81"
					y1="378.41"
					x2="562.81"
					y2="375.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="666.66 387.54 671.22 387.54 671.22 378.41 666.66 378.41 666.66 387.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="561.67 387.54 566.24 387.54 566.24 378.41 561.67 378.41 561.67 387.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="618.73 378.41 566.24 378.41 566.24 382.41 618.73 382.41 618.73 378.41"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="639.27 382.41 586.78 382.41 586.78 386.4 639.27 386.4 639.27 382.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="671.22"
					y1="378.41"
					x2="671.79"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.22"
					y1="387.54"
					x2="671.79"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.79"
					y1="378.41"
					x2="671.79"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.67"
					y1="378.41"
					x2="561.1"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.67"
					y1="387.54"
					x2="561.1"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.1"
					y1="378.41"
					x2="561.1"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.66"
					y1="387.54"
					x2="666.66"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.66"
					y1="378.41"
					x2="671.22"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.22"
					y1="378.41"
					x2="671.22"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.22"
					y1="387.54"
					x2="666.66"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.67"
					y1="387.54"
					x2="561.67"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.67"
					y1="378.41"
					x2="566.24"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.24"
					y1="378.41"
					x2="566.24"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.24"
					y1="387.54"
					x2="561.67"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.73"
					y1="378.41"
					x2="618.73"
					y2="382.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.73"
					y1="382.41"
					x2="566.24"
					y2="382.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.24"
					y1="382.41"
					x2="566.24"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.24"
					y1="378.41"
					x2="618.73"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="639.27"
					y1="382.41"
					x2="639.27"
					y2="386.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="639.27"
					y1="386.4"
					x2="586.78"
					y2="386.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.78"
					y1="386.4"
					x2="586.78"
					y2="382.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.78"
					y1="382.41"
					x2="639.27"
					y2="382.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.79"
					y1="378.41"
					x2="671.79"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="671.79"
					y1="378.41"
					x2="671.79"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="671.79"
					y1="387.54"
					x2="671.79"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="671.79"
					y1="378.41"
					x2="674.65"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="671.79"
					y1="387.54"
					x2="671.79"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="671.79"
					y1="389.83"
					x2="674.65"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="671.79"
					y1="389.83"
					x2="674.65"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="561.1"
					y1="378.41"
					x2="561.1"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="561.1"
					y1="378.41"
					x2="561.1"
					y2="387.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="561.1"
					y1="387.54"
					x2="561.1"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="561.1"
					y1="378.41"
					x2="558.25"
					y2="378.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="561.1"
					y1="387.54"
					x2="561.1"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="561.1"
					y1="389.83"
					x2="558.25"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="561.1"
					y1="389.83"
					x2="558.25"
					y2="389.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="793.92"
					y1="600.07"
					x2="776.57"
					y2="600.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="776.57"
					y1="600.07"
					x2="776.57"
					y2="611.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="776.57"
					y1="611.48"
					x2="776.57"
					y2="670.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="470.38"
					y1="50"
					x2="470.38"
					y2="68.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="603.38"
					y1="68.26"
					x2="606.57"
					y2="68.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="606.57"
					y1="68.26"
					x2="606.57"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="290.88"
					y1="50"
					x2="290.88"
					y2="68.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="733.99 488.47 732.17 492.54 731.54 496.95 732.17 501.37 733.99 505.44 736.3 508.12 739.19 510.16 745.98 512.75 754.48 513.64 762.82 511.74 770.3 512.36 777.14 515.48 779.07 516.72 783.04 518.16 787.25 517.94 788.92 517.29 793.35 517.29 793.35 515.44 791.33 515.44 793.2 512.35 793.92 508.81 793.92 485.1 792.69 480.52 789.43 477.07 784.92 475.6 784.37 475.6 781.52 476.07 777.04 478.47 770.28 481.58 762.87 482.19 754.51 480.26 745.98 481.16 739.19 483.74 736.3 485.78 733.99 488.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="772.85"
					y1="505.4"
					x2="772.85"
					y2="488.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.92"
					y1="485.1"
					x2="793.92"
					y2="496.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.07"
					y1="485.1"
					x2="793.07"
					y2="496.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.92"
					y1="508.81"
					x2="793.92"
					y2="496.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.07"
					y1="508.81"
					x2="793.07"
					y2="496.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.85"
					y1="488.94"
					x2="776"
					y2="488.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776"
					y1="488.94"
					x2="776"
					y2="491.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776"
					y1="491.55"
					x2="772.85"
					y2="491.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.85"
					y1="504.96"
					x2="776"
					y2="504.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776"
					y1="504.96"
					x2="776"
					y2="502.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776"
					y1="502.35"
					x2="772.85"
					y2="502.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.5"
					y1="515.44"
					x2="793.35"
					y2="515.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.5"
					y1="517.29"
					x2="793.35"
					y2="517.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.35"
					y1="517.29"
					x2="793.35"
					y2="515.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.5"
					y1="517.29"
					x2="785.5"
					y2="515.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.54"
					y1="496.95"
					x2="731.86"
					y2="494.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.86"
					y1="494.12"
					x2="732.59"
					y2="491.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.59"
					y1="491.38"
					x2="733.99"
					y2="488.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.99"
					y1="488.47"
					x2="736.29"
					y2="485.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.29"
					y1="485.78"
					x2="739.19"
					y2="483.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.19"
					y1="483.74"
					x2="742.48"
					y2="482.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.48"
					y1="482.25"
					x2="745.98"
					y2="481.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.98"
					y1="481.16"
					x2="751.63"
					y2="480.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.63"
					y1="480.17"
					x2="754.48"
					y2="480.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.48"
					y1="480.12"
					x2="757.32"
					y2="480.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.32"
					y1="480.44"
					x2="761.73"
					y2="481.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.73"
					y1="481.72"
					x2="765.99"
					y2="483.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.99"
					y1="483.72"
					x2="769.8"
					y2="486.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.8"
					y1="486.1"
					x2="772.85"
					y2="488.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.87"
					y1="482.19"
					x2="766.83"
					y2="482.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.83"
					y1="482.17"
					x2="770.68"
					y2="481.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.68"
					y1="481.52"
					x2="772.75"
					y2="480.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.75"
					y1="480.85"
					x2="774.81"
					y2="479.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.81"
					y1="479.88"
					x2="777.8"
					y2="477.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.8"
					y1="477.97"
					x2="780.89"
					y2="476.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.89"
					y1="476.29"
					x2="783.91"
					y2="475.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.91"
					y1="475.62"
					x2="786.92"
					y2="475.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.92"
					y1="475.88"
					x2="789.66"
					y2="477.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.66"
					y1="477.05"
					x2="791.86"
					y2="479.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.86"
					y1="479.12"
					x2="792.98"
					y2="481.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.98"
					y1="481.14"
					x2="793.6"
					y2="483.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.6"
					y1="483.08"
					x2="793.92"
					y2="485.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.07"
					y1="485.1"
					x2="792.98"
					y2="484.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.98"
					y1="484.19"
					x2="792.41"
					y2="482.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.41"
					y1="482.33"
					x2="791.02"
					y2="480.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.02"
					y1="480.68"
					x2="789.09"
					y2="479.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.09"
					y1="479.65"
					x2="786.54"
					y2="479.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.54"
					y1="479.16"
					x2="783.92"
					y2="479.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.92"
					y1="479.05"
					x2="782.61"
					y2="479.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.61"
					y1="479.06"
					x2="781.58"
					y2="479.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.58"
					y1="479.61"
					x2="781.28"
					y2="480.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.28"
					y1="480.25"
					x2="779.24"
					y2="487.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.24"
					y1="487.42"
					x2="778.64"
					y2="490.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.64"
					y1="490.99"
					x2="778.37"
					y2="494.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.37"
					y1="494.6"
					x2="778.37"
					y2="496.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.82"
					y1="511.74"
					x2="766.78"
					y2="511.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.78"
					y1="511.77"
					x2="770.65"
					y2="512.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.65"
					y1="512.41"
					x2="774.81"
					y2="514.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.81"
					y1="514.02"
					x2="777.8"
					y2="515.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.8"
					y1="515.92"
					x2="780.89"
					y2="517.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.89"
					y1="517.61"
					x2="782.9"
					y2="518.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.9"
					y1="518.17"
					x2="784.98"
					y2="518.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.98"
					y1="518.3"
					x2="787.01"
					y2="518.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.01"
					y1="518.01"
					x2="788.92"
					y2="517.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.07"
					y1="508.81"
					x2="792.98"
					y2="509.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.98"
					y1="509.71"
					x2="792.41"
					y2="511.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.41"
					y1="511.57"
					x2="791.02"
					y2="513.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.02"
					y1="513.22"
					x2="789.09"
					y2="514.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.09"
					y1="514.25"
					x2="786.54"
					y2="514.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.54"
					y1="514.75"
					x2="783.92"
					y2="514.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.92"
					y1="514.86"
					x2="782.61"
					y2="514.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.61"
					y1="514.84"
					x2="781.58"
					y2="514.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.58"
					y1="514.29"
					x2="781.28"
					y2="513.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.28"
					y1="513.65"
					x2="779.24"
					y2="506.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.24"
					y1="506.48"
					x2="778.64"
					y2="502.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.64"
					y1="502.91"
					x2="778.37"
					y2="499.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.37"
					y1="499.31"
					x2="778.37"
					y2="496.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.54"
					y1="496.95"
					x2="731.86"
					y2="499.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.86"
					y1="499.78"
					x2="732.59"
					y2="502.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.59"
					y1="502.53"
					x2="733.99"
					y2="505.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.99"
					y1="505.44"
					x2="736.29"
					y2="508.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.29"
					y1="508.13"
					x2="739.19"
					y2="510.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.19"
					y1="510.16"
					x2="742.48"
					y2="511.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.48"
					y1="511.66"
					x2="745.98"
					y2="512.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.98"
					y1="512.75"
					x2="751.63"
					y2="513.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.63"
					y1="513.73"
					x2="754.48"
					y2="513.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.48"
					y1="513.78"
					x2="757.32"
					y2="513.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.32"
					y1="513.46"
					x2="761.73"
					y2="512.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.73"
					y1="512.18"
					x2="765.99"
					y2="510.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.99"
					y1="510.18"
					x2="769.8"
					y2="507.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.8"
					y1="507.81"
					x2="772.85"
					y2="505.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.24"
					y1="477.08"
					x2="778.6"
					y2="477.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.6"
					y1="477.54"
					x2="777.64"
					y2="478.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.64"
					y1="478.84"
					x2="777.41"
					y2="479.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.41"
					y1="479.97"
					x2="776.79"
					y2="487.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.79"
					y1="487.26"
					x2="776.51"
					y2="494.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.51"
					y1="494.56"
					x2="776.51"
					y2="496.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.24"
					y1="516.82"
					x2="778.6"
					y2="516.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.6"
					y1="516.37"
					x2="777.64"
					y2="515.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.64"
					y1="515.06"
					x2="777.41"
					y2="513.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.41"
					y1="513.93"
					x2="776.79"
					y2="506.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.79"
					y1="506.64"
					x2="776.51"
					y2="499.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.51"
					y1="499.34"
					x2="776.51"
					y2="496.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.33"
					y1="515.44"
					x2="791.86"
					y2="514.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.86"
					y1="514.79"
					x2="792.98"
					y2="512.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.98"
					y1="512.76"
					x2="793.6"
					y2="510.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.6"
					y1="510.83"
					x2="793.92"
					y2="508.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="793.92 469.56 793.01 469.56 793.01 474.13 793.92 474.13 793.92 469.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="793.92"
					y1="474.13"
					x2="793.92"
					y2="469.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.01"
					y1="474.13"
					x2="793.92"
					y2="474.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.01"
					y1="469.56"
					x2="793.01"
					y2="474.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.92"
					y1="469.56"
					x2="793.01"
					y2="469.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="793.92 524.34 793.92 519.78 793.01 519.78 793.01 524.34 793.92 524.34"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="793.01"
					y1="524.34"
					x2="793.92"
					y2="524.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.01"
					y1="519.78"
					x2="793.01"
					y2="524.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.92"
					y1="519.78"
					x2="793.01"
					y2="519.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.92"
					y1="524.34"
					x2="793.92"
					y2="519.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="793.01 471.39 785.58 471.39 785.58 472.3 793.01 472.3 793.01 471.39"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="793.01"
					y1="472.3"
					x2="793.01"
					y2="471.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.58"
					y1="472.3"
					x2="793.01"
					y2="472.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.58"
					y1="471.39"
					x2="785.58"
					y2="472.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.01"
					y1="471.39"
					x2="785.58"
					y2="471.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="793.01 522.51 793.01 521.6 785.58 521.6 785.58 522.51 793.01 522.51"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="785.58"
					y1="522.51"
					x2="793.01"
					y2="522.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.58"
					y1="521.6"
					x2="785.58"
					y2="522.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.01"
					y1="521.6"
					x2="785.58"
					y2="521.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.01"
					y1="522.51"
					x2="793.01"
					y2="521.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="787.87 472.3 786.04 472.3 786.04 521.6 787.87 521.6 787.87 472.3"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="787.87"
					y1="521.6"
					x2="787.87"
					y2="472.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.04"
					y1="521.6"
					x2="787.87"
					y2="521.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.04"
					y1="472.3"
					x2="786.04"
					y2="521.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.87"
					y1="472.3"
					x2="786.04"
					y2="472.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="638.11 600.07 638.11 670.95 776.57 670.95 776.57 600.07 638.11 600.07"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="776.57"
					y1="600.07"
					x2="638.11"
					y2="600.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.57"
					y1="670.95"
					x2="776.57"
					y2="600.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.11"
					y1="670.95"
					x2="776.57"
					y2="670.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.11"
					y1="600.07"
					x2="638.11"
					y2="670.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.08"
					y1="604.56"
					x2="642.6"
					y2="604.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.6"
					y1="604.56"
					x2="642.6"
					y2="666.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.6"
					y1="666.45"
					x2="772.08"
					y2="666.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.08"
					y1="666.45"
					x2="772.08"
					y2="604.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.08"
					y1="604.56"
					x2="713.92"
					y2="632.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.08"
					y1="666.45"
					x2="713.92"
					y2="638.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.6"
					y1="604.56"
					x2="700.76"
					y2="632.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.6"
					y1="666.45"
					x2="700.76"
					y2="638.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.34"
					y1="631.02"
					x2="707.34"
					y2="640"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="702.85"
					y1="635.51"
					x2="711.83"
					y2="635.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m714.53,635.51c0-3.97-3.22-7.19-7.19-7.19s-7.19,3.22-7.19,7.19,3.22,7.19,7.19,7.19,7.19-3.22,7.19-7.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m711.83,635.51c0-2.48-2.01-4.49-4.49-4.49s-4.49,2.01-4.49,4.49,2.01,4.49,4.49,4.49,4.49-2.01,4.49-4.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="776.57 635.51 767.04 628.49 767.04 642.52 776.57 635.51"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="767.04"
					y1="642.52"
					x2="776.57"
					y2="635.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.04"
					y1="628.49"
					x2="767.04"
					y2="642.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.57"
					y1="635.51"
					x2="767.04"
					y2="628.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.86"
					y1="635.51"
					x2="759.01"
					y2="635.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.04"
					y1="635.51"
					x2="767.04"
					y2="642.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.04"
					y1="642.52"
					x2="776.57"
					y2="635.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.04"
					y1="635.51"
					x2="767.04"
					y2="628.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.04"
					y1="628.49"
					x2="776.57"
					y2="635.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.04"
					y1="637.58"
					x2="759.96"
					y2="640.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.04"
					y1="633.44"
					x2="759.96"
					y2="630.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="311.04 664.59 258.96 664.59 258.96 715.77 311.04 715.77 311.04 664.59"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="311.04"
					y1="715.77"
					x2="311.04"
					y2="713.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.04"
					y1="710.45"
					x2="311.04"
					y2="704.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.04"
					y1="701.68"
					x2="311.04"
					y2="696.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.04"
					y1="692.92"
					x2="311.04"
					y2="687.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.04"
					y1="684.15"
					x2="311.04"
					y2="678.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.04"
					y1="675.39"
					x2="311.04"
					y2="669.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.04"
					y1="666.63"
					x2="311.04"
					y2="664.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.96"
					y1="715.77"
					x2="261.44"
					y2="715.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.73"
					y1="715.77"
					x2="270.21"
					y2="715.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.49"
					y1="715.77"
					x2="278.97"
					y2="715.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="282.26"
					y1="715.77"
					x2="287.74"
					y2="715.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.02"
					y1="715.77"
					x2="296.5"
					y2="715.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.79"
					y1="715.77"
					x2="305.26"
					y2="715.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="308.55"
					y1="715.77"
					x2="311.04"
					y2="715.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.96"
					y1="664.59"
					x2="258.96"
					y2="666.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.96"
					y1="669.91"
					x2="258.96"
					y2="675.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.96"
					y1="678.68"
					x2="258.96"
					y2="684.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.96"
					y1="687.44"
					x2="258.96"
					y2="692.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.96"
					y1="696.2"
					x2="258.96"
					y2="701.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.96"
					y1="704.97"
					x2="258.96"
					y2="710.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.96"
					y1="713.73"
					x2="258.96"
					y2="715.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.04"
					y1="664.59"
					x2="308.55"
					y2="664.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.26"
					y1="664.59"
					x2="299.79"
					y2="664.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="296.5"
					y1="664.59"
					x2="291.02"
					y2="664.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.74"
					y1="664.59"
					x2="282.26"
					y2="664.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.97"
					y1="664.59"
					x2="273.49"
					y2="664.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="270.21"
					y1="664.59"
					x2="264.73"
					y2="664.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.44"
					y1="664.59"
					x2="258.96"
					y2="664.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="313.73 715.57 315.3 715.57 315.3 664.78 313.73 664.78 313.73 672.75 315.02 672.75 315.02 707.61 313.73 707.61 313.73 715.57"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="313.73"
					y1="707.61"
					x2="313.73"
					y2="715.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="315.02"
					y1="707.61"
					x2="313.73"
					y2="707.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="315.02"
					y1="672.75"
					x2="315.02"
					y2="707.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="313.73"
					y1="672.75"
					x2="315.02"
					y2="672.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="313.73"
					y1="664.78"
					x2="313.73"
					y2="672.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="315.3"
					y1="664.78"
					x2="313.73"
					y2="664.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="315.3"
					y1="715.57"
					x2="315.3"
					y2="664.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="313.73"
					y1="715.57"
					x2="315.3"
					y2="715.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<polyline
					points="313.73 717.57 313.73 662.79 311.04 662.79 311.04 717.57 313.73 717.57"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="311.04"
					y1="717.57"
					x2="313.73"
					y2="717.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="311.04"
					y1="662.79"
					x2="311.04"
					y2="717.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="313.73"
					y1="662.79"
					x2="311.04"
					y2="662.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="313.73"
					y1="717.57"
					x2="313.73"
					y2="662.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="313.73"
					y1="664.78"
					x2="315.3"
					y2="664.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.3"
					y1="664.78"
					x2="315.3"
					y2="715.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.3"
					y1="715.57"
					x2="313.73"
					y2="715.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.73"
					y1="662.79"
					x2="313.73"
					y2="717.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.73"
					y1="707.61"
					x2="315.02"
					y2="707.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.02"
					y1="707.61"
					x2="315.02"
					y2="672.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.02"
					y1="672.75"
					x2="313.73"
					y2="672.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.04"
					y1="662.79"
					x2="313.73"
					y2="662.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.73"
					y1="717.57"
					x2="311.04"
					y2="717.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.04"
					y1="717.57"
					x2="311.04"
					y2="662.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="333.7 425.59 333.7 502.11 258.96 502.11 258.96 425.59 333.7 425.59"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="333.7"
					y1="425.59"
					x2="333.7"
					y2="502.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.7"
					y1="502.11"
					x2="258.96"
					y2="502.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.96"
					y1="502.11"
					x2="258.96"
					y2="425.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.96"
					y1="425.59"
					x2="333.7"
					y2="425.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.99"
					y1="425.59"
					x2="327.99"
					y2="502.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="307.17 656.45 307.17 599.59 306.64 598.32 305.37 597.8 267.32 597.8 266.04 598.32 265.52 599.59 265.52 656.45 266.04 657.72 267.32 658.24 305.37 658.24 306.64 657.72 307.17 656.45"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m307.17,656.45c0,.99-.81,1.8-1.8,1.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.32"
					y1="658.24"
					x2="305.37"
					y2="658.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m267.32,658.24c-.99,0-1.8-.81-1.8-1.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.52"
					y1="599.59"
					x2="265.52"
					y2="656.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m265.52,599.59c0-.99.8-1.8,1.8-1.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.37"
					y1="597.8"
					x2="267.32"
					y2="597.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m305.37,597.8c.99,0,1.8.81,1.8,1.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="307.17"
					y1="656.45"
					x2="307.17"
					y2="599.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.68"
					y1="651.96"
					x2="302.68"
					y2="604.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.88"
					y1="602.29"
					x2="276.3"
					y2="602.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.5"
					y1="604.09"
					x2="274.5"
					y2="651.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.3"
					y1="653.75"
					x2="300.88"
					y2="653.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.68"
					y1="651.96"
					x2="302.68"
					y2="651.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m300.88,602.29c.99,0,1.8.8,1.8,1.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m274.5,604.09c0-.99.8-1.8,1.8-1.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m276.3,653.75c-.99,0-1.8-.81-1.8-1.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m302.68,651.96c0,.99-.81,1.8-1.8,1.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m286.18,628.02c0-1.49-1.21-2.69-2.7-2.69s-2.7,1.21-2.7,2.69,1.21,2.69,2.7,2.69,2.7-1.2,2.7-2.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="286 628.83 286.57 628.59 286.8 628.02 286.56 627.45 285.99 627.21 268.21 627.21 267.64 627.45 267.41 628.02 267.64 628.59 268.21 628.83 286 628.83"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="268.21"
					y1="628.83"
					x2="286"
					y2="628.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m268.21,628.83c-.45,0-.81-.36-.81-.81s.36-.81.81-.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="285.99"
					y1="627.21"
					x2="268.21"
					y2="627.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m285.99,627.21h0c.45,0,.81.36.81.81s-.36.81-.81.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="272.8 629.81 272.8 628.83 268.21 628.83 267.64 628.59 267.41 628.02 267.64 627.45 268.21 627.21 272.8 627.21 272.8 626.23 266.96 626.23 266.96 629.81 272.8 629.81"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="266.96"
					y1="629.81"
					x2="272.8"
					y2="629.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.96"
					y1="626.23"
					x2="266.96"
					y2="629.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.8"
					y1="626.23"
					x2="266.96"
					y2="626.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.8"
					y1="627.21"
					x2="272.8"
					y2="626.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.21"
					y1="627.21"
					x2="272.8"
					y2="627.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m268.21,628.83c-.45,0-.81-.36-.81-.81s.36-.81.81-.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.8"
					y1="628.83"
					x2="268.21"
					y2="628.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.8"
					y1="629.81"
					x2="272.8"
					y2="628.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="276.03 629.79 276.03 628.83 272.89 628.83 272.89 629.79 276.03 629.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="272.89"
					y1="629.79"
					x2="276.03"
					y2="629.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.89"
					y1="628.83"
					x2="272.89"
					y2="629.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.03"
					y1="628.83"
					x2="272.89"
					y2="628.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.03"
					y1="629.79"
					x2="276.03"
					y2="628.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="276.03 626.25 272.89 626.25 272.89 627.21 276.03 627.21 276.03 626.25"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="276.03"
					y1="627.21"
					x2="276.03"
					y2="626.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.89"
					y1="627.21"
					x2="276.03"
					y2="627.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.89"
					y1="626.25"
					x2="272.89"
					y2="627.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.03"
					y1="626.25"
					x2="272.89"
					y2="626.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="748.3 538.09 748.3 597.43 793.92 597.43 793.92 538.09 748.3 538.09"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="748.3"
					y1="538.09"
					x2="748.3"
					y2="597.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.92"
					y1="538.09"
					x2="793.92"
					y2="597.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.3"
					y1="597.43"
					x2="793.92"
					y2="597.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.3"
					y1="538.09"
					x2="793.92"
					y2="538.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.13"
					y1="538.09"
					x2="792.13"
					y2="597.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.13"
					y1="544.93"
					x2="759.13"
					y2="590.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.13"
					y1="590.58"
					x2="786.52"
					y2="590.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.52"
					y1="590.58"
					x2="786.52"
					y2="544.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.52"
					y1="544.93"
					x2="759.13"
					y2="544.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.33"
					y1="543.14"
					x2="757.33"
					y2="592.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.33"
					y1="592.38"
					x2="788.31"
					y2="592.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.31"
					y1="592.38"
					x2="788.31"
					y2="543.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.31"
					y1="543.14"
					x2="757.33"
					y2="543.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m783.03,567.76c0-1.49-1.21-2.69-2.7-2.69s-2.69,1.21-2.69,2.69,1.21,2.69,2.69,2.69,2.7-1.2,2.7-2.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="791.46 565.51 787.69 565.87 786.83 566.16 782.08 566.76 781.45 567.09 781.2 567.76 781.45 568.42 782.08 568.76 786.83 569.35 787.69 569.64 791.46 570 792.78 569.57 793.59 568.45 793.59 567.07 792.78 565.94 791.46 565.51"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m791.46,565.51c1.24,0,2.25,1,2.25,2.25s-1.01,2.25-2.25,2.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.69"
					y1="569.64"
					x2="791.46"
					y2="570"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m787.69,569.64c-.3-.03-.6-.13-.86-.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.08"
					y1="568.76"
					x2="786.83"
					y2="569.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m782.08,568.76c-.5-.06-.88-.49-.88-1s.38-.93.88-1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.83"
					y1="566.16"
					x2="782.08"
					y2="566.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m786.83,566.16c.26-.16.55-.27.86-.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.46"
					y1="565.51"
					x2="787.69"
					y2="565.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.22"
					y1="568.98"
					x2="787.89"
					y2="568.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.89"
					y1="566.54"
					x2="789.22"
					y2="566.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.22"
					y1="566.54"
					x2="789.22"
					y2="568.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m787.89,568.98c-.68,0-1.22-.55-1.22-1.22s.55-1.22,1.22-1.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m786.83,569.35c-.54-.35-.87-.95-.87-1.59s.33-1.24.87-1.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.46"
					y1="623.73"
					x2="539.46"
					y2="609.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.46"
					y1="609.1"
					x2="579.14"
					y2="609.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.11"
					y1="623.73"
					x2="587.5"
					y2="623.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.5"
					y1="661.32"
					x2="531.11"
					y2="661.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.11"
					y1="661.32"
					x2="531.11"
					y2="604.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.5"
					y1="604.93"
					x2="587.5"
					y2="661.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.11"
					y1="605.97"
					x2="587.5"
					y2="605.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.14"
					y1="623.73"
					x2="579.14"
					y2="609.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.11"
					y1="604.93"
					x2="587.5"
					y2="604.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.73"
					y1="788.48"
					x2="313.73"
					y2="502.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.7"
					y1="499.56"
					x2="338.74"
					y2="499.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.74"
					y1="499.56"
					x2="338.74"
					y2="497.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.74"
					y1="497.01"
					x2="333.7"
					y2="497.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.78"
					y1="425.59"
					x2="325.78"
					y2="427.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.78"
					y1="430.44"
					x2="325.78"
					y2="435.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.78"
					y1="439.2"
					x2="325.78"
					y2="444.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.78"
					y1="447.96"
					x2="325.78"
					y2="453.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.78"
					y1="456.73"
					x2="325.78"
					y2="462.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.78"
					y1="465.49"
					x2="325.78"
					y2="470.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.78"
					y1="474.26"
					x2="325.78"
					y2="479.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.78"
					y1="483.02"
					x2="325.78"
					y2="488.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.78"
					y1="491.78"
					x2="325.78"
					y2="497.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.78"
					y1="500.41"
					x2="325.78"
					y2="502.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.73"
					y1="788.48"
					x2="258.96"
					y2="788.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.88"
					y1="50"
					x2="470.38"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="470.38"
					y1="68.26"
					x2="290.88"
					y2="68.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.01"
					y1="50"
					x2="606.57"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.57"
					y1="68.26"
					x2="759.01"
					y2="68.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.46"
					y1="655.05"
					x2="579.14"
					y2="655.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.14"
					y1="655.05"
					x2="579.14"
					y2="627.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.14"
					y1="627.9"
					x2="539.46"
					y2="627.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.46"
					y1="627.9"
					x2="539.46"
					y2="655.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="318.3 593.25 318.3 524.78 258.96 524.78 258.96 593.25 318.3 593.25"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="318.3"
					y1="593.25"
					x2="318.3"
					y2="524.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.96"
					y1="593.25"
					x2="258.96"
					y2="524.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.75"
					y1="593.25"
					x2="260.75"
					y2="524.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.3"
					y1="593.25"
					x2="258.96"
					y2="593.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.3"
					y1="524.78"
					x2="258.96"
					y2="524.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.6"
					y1="588.76"
					x2="315.6"
					y2="529.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.6"
					y1="529.27"
					x2="313.8"
					y2="527.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.8"
					y1="527.48"
					x2="263.45"
					y2="527.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.45"
					y1="527.48"
					x2="261.65"
					y2="529.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.65"
					y1="529.27"
					x2="261.65"
					y2="588.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.65"
					y1="588.76"
					x2="263.45"
					y2="590.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.45"
					y1="590.56"
					x2="313.8"
					y2="590.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.8"
					y1="590.56"
					x2="315.6"
					y2="588.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m312.45,576.13c0-4.96-4.02-8.98-8.99-8.98s-8.98,4.02-8.98,8.98,4.02,8.99,8.98,8.99,8.99-4.02,8.99-8.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m280.53,576.13c0-3.72-3.02-6.74-6.74-6.74s-6.74,3.02-6.74,6.74,3.02,6.74,6.74,6.74,6.74-3.02,6.74-6.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m310.2,541.9c0-3.72-3.02-6.74-6.74-6.74s-6.74,3.02-6.74,6.74,3.02,6.74,6.74,6.74,6.74-3.02,6.74-6.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m282.78,541.9c0-4.96-4.02-8.98-8.99-8.98s-8.99,4.02-8.99,8.98,4.02,8.99,8.99,8.99,8.99-4.02,8.99-8.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="788.48"
					x2="286.34"
					y2="782.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="779.49"
					x2="286.34"
					y2="774.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="770.73"
					x2="286.34"
					y2="765.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="761.97"
					x2="286.34"
					y2="756.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="753.2"
					x2="286.34"
					y2="747.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="744.44"
					x2="286.34"
					y2="738.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="735.67"
					x2="286.34"
					y2="730.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="726.91"
					x2="286.34"
					y2="721.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="718.15"
					x2="286.34"
					y2="712.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="709.38"
					x2="286.34"
					y2="703.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="700.62"
					x2="286.34"
					y2="695.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="691.85"
					x2="286.34"
					y2="686.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="683.09"
					x2="286.34"
					y2="677.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="674.33"
					x2="286.34"
					y2="668.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="665.56"
					x2="286.34"
					y2="660.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="656.8"
					x2="286.34"
					y2="651.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="648.03"
					x2="286.34"
					y2="642.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="639.27"
					x2="286.34"
					y2="633.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="630.51"
					x2="286.34"
					y2="625.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="621.74"
					x2="286.34"
					y2="616.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="612.98"
					x2="286.34"
					y2="607.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="604.21"
					x2="286.34"
					y2="598.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="595.45"
					x2="286.34"
					y2="589.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="586.69"
					x2="286.34"
					y2="581.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="577.92"
					x2="286.34"
					y2="572.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="569.16"
					x2="286.34"
					y2="563.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="560.39"
					x2="286.34"
					y2="554.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="551.63"
					x2="286.34"
					y2="546.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="542.87"
					x2="286.34"
					y2="537.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="534.1"
					x2="286.34"
					y2="528.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="525.34"
					x2="286.34"
					y2="519.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="516.57"
					x2="286.34"
					y2="511.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.34"
					y1="507.81"
					x2="286.34"
					y2="502.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="606.56 50 606.56 68.26 603.38 68.26 603.38 143.87 555.13 143.87 555.13 285.76 543.71 285.76 543.71 143.87 534.06 143.87 534.06 68.26 470.38 68.26 470.38 50 606.56 50"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.19"
				/>
				<polygon
					points="834.77 50 834.77 689.21 419.62 689.21 419.62 948.86 396.13 948.86 396.13 930.6 401.36 930.6 401.36 670.95 508.68 670.95 508.68 585.87 528.67 585.87 528.67 597.29 520.09 597.29 520.09 670.95 598.68 670.95 598.68 597.29 588.01 597.29 588.01 585.87 626.7 585.87 626.7 549.36 638.11 549.36 638.11 670.95 776.57 670.95 776.57 600.07 793.92 600.07 793.92 451.46 638.11 451.46 638.11 462.62 626.7 462.62 626.7 451.46 543.71 451.46 543.71 372.49 555.13 372.49 555.13 378.42 561.1 378.42 561.1 389.83 555.13 389.83 555.13 440.05 679.39 440.05 679.39 389.83 671.8 389.83 671.8 378.42 697.53 378.42 697.53 389.83 690.8 389.83 690.8 440.05 816.52 440.05 816.52 389.83 808.22 389.83 808.22 378.42 816.52 378.42 816.52 68.26 759.01 68.26 759.01 50 834.77 50"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.19"
				/>
				<polygon
					points="309.41 930.6 309.41 948.86 165.23 948.86 165.23 782.54 240.7 782.54 240.7 50 290.87 50 290.87 68.26 258.96 68.26 258.96 805.31 247.55 805.31 247.55 800.79 183.48 800.79 183.48 930.6 247.55 930.6 247.55 869.21 258.96 869.21 258.96 930.6 309.41 930.6"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.19"
				/>
			</g>
			<g id="text">
				<path d="m261.18,694.95v-10.59h3.65c.82,0,1.45.05,1.89.15.61.14,1.12.39,1.55.76.56.47.98,1.08,1.25,1.81.28.73.42,1.57.42,2.51,0,.8-.09,1.52-.28,2.14-.19.62-.43,1.14-.72,1.55-.29.4-.62.72-.97.96-.35.23-.77.41-1.26.53-.49.12-1.06.18-1.7.18h-3.82Zm1.4-1.25h2.26c.7,0,1.24-.06,1.64-.19.4-.13.72-.31.95-.55.33-.33.59-.78.77-1.34.19-.56.28-1.24.28-2.04,0-1.11-.18-1.96-.55-2.55-.36-.6-.8-1-1.32-1.2-.38-.14-.98-.22-1.81-.22h-2.22v8.09Zm11.13,1.25l-2.81-10.59h1.44l1.61,6.94c.17.73.32,1.45.45,2.17.27-1.13.43-1.78.48-1.96l2.02-7.15h1.69l1.52,5.36c.38,1.33.65,2.58.82,3.75.13-.67.31-1.44.53-2.3l1.66-6.8h1.41l-2.9,10.59h-1.35l-2.23-8.07c-.19-.67-.3-1.09-.33-1.24-.11.49-.21.9-.31,1.24l-2.25,8.07h-1.43Z" />
				<path d="m292.98,470.19h-1.49l-1.78-2.99c-.16-.28-.32-.51-.48-.71-.15-.2-.31-.36-.48-.48-.16-.12-.33-.21-.52-.27-.18-.06-.39-.09-.62-.09h-1.03v4.53h-1.25v-10.66h3.18c.47,0,.89.06,1.29.18.4.11.74.29,1.03.53.29.24.52.54.68.89.16.35.25.77.25,1.24,0,.37-.06.71-.17,1.03-.11.31-.27.58-.48.83-.2.24-.45.45-.74.62-.29.17-.61.3-.97.39v.03c.18.08.33.17.46.28.13.1.26.22.38.36.12.14.24.3.35.48.12.17.25.38.39.61l2,3.2Zm-6.39-9.53v3.87h1.69c.31,0,.6-.05.86-.14.27-.09.5-.23.69-.4.19-.18.34-.39.45-.65.11-.26.16-.55.16-.86,0-.57-.19-1.01-.56-1.33-.37-.32-.9-.48-1.6-.48h-1.71Zm13.67,6.03h-5.37c.02.85.25,1.5.68,1.96.44.46,1.04.69,1.8.69.86,0,1.65-.28,2.36-.85v1.14c-.67.49-1.55.73-2.65.73s-1.92-.34-2.53-1.03c-.61-.69-.92-1.67-.92-2.92,0-1.18.33-2.15,1-2.89.67-.75,1.51-1.12,2.5-1.12s1.77.32,2.31.97c.55.64.82,1.54.82,2.68v.64Zm-1.25-1.03c0-.7-.18-1.25-.51-1.64-.33-.39-.8-.59-1.39-.59s-1.06.21-1.46.62c-.4.41-.65.95-.74,1.61h4.11Zm6.72-5.66c-.24-.13-.51-.2-.81-.2-.85,0-1.28.54-1.28,1.61v1.17h1.78v1.04h-1.78v6.57h-1.21v-6.57h-1.3v-1.04h1.3v-1.23c0-.8.23-1.43.69-1.89.46-.47,1.04-.7,1.72-.7.37,0,.67.04.88.13v1.1Z" />
				<path d="m307.02,470.35c-.23,0-.42-.08-.59-.25-.16-.16-.24-.36-.24-.59s.08-.42.24-.59c.16-.17.36-.25.59-.25s.43.08.59.25c.16.16.25.36.25.59s-.08.42-.25.59c-.16.16-.36.25-.59.25Z" />
				<path d="m671.9,575.03v-16.54h4.71c1.43,0,2.56.35,3.4,1.05.84.7,1.26,1.61,1.26,2.73,0,.94-.25,1.75-.76,2.45s-1.21,1.18-2.1,1.48v.05c1.11.13,2.01.55,2.68,1.27.67.71,1,1.63,1,2.77,0,1.41-.51,2.56-1.52,3.44-1.02.88-2.3,1.31-3.84,1.31h-4.82Zm1.94-14.79v5.34h1.98c1.06,0,1.9-.25,2.5-.76.61-.52.91-1.24.91-2.17,0-1.61-1.06-2.41-3.17-2.41h-2.23Zm0,7.08v5.95h2.63c1.14,0,2.02-.27,2.64-.81.63-.54.95-1.28.95-2.21,0-1.95-1.33-2.93-3.99-2.93h-2.23Zm19.8,7.7h-1.89v-1.85h-.05c-.82,1.41-2.03,2.12-3.63,2.12-1.18,0-2.1-.31-2.77-.93-.66-.62-.99-1.45-.99-2.48,0-2.21,1.3-3.49,3.9-3.85l3.54-.5c0-2.01-.81-3.01-2.43-3.01-1.42,0-2.71.48-3.85,1.45v-1.94c1.16-.74,2.5-1.11,4.01-1.11,2.78,0,4.16,1.47,4.16,4.41v7.68Zm-1.89-5.97l-2.85.39c-.88.12-1.54.34-1.98.66-.45.31-.67.86-.67,1.65,0,.58.2,1.05.61,1.42.42.36.97.54,1.65.54.94,0,1.71-.33,2.32-.98.62-.66.92-1.5.92-2.5v-1.18Zm10.94,5.86c-.45.25-1.03.37-1.76.37-2.07,0-3.1-1.15-3.1-3.46v-6.99h-2.03v-1.61h2.03v-2.88l1.89-.61v3.49h2.98v1.61h-2.98v6.66c0,.79.13,1.36.4,1.7.27.34.72.51,1.34.51.48,0,.89-.13,1.23-.39v1.61Zm12.33.12h-1.89v-6.81c0-2.46-.92-3.69-2.75-3.69-.92,0-1.7.36-2.33,1.07-.63.71-.95,1.62-.95,2.73v6.69h-1.89v-17.49h1.89v7.64h.05c.91-1.49,2.2-2.24,3.88-2.24,2.66,0,3.99,1.6,3.99,4.81v7.28Z" />
				<path d="m314.55,863.03h-8.77v-16.54h8.4v1.75h-6.46v5.5h5.97v1.74h-5.97v5.79h6.83v1.75Zm12.76,0h-1.89v-6.74c0-2.51-.92-3.76-2.75-3.76-.95,0-1.73.36-2.35,1.07-.62.71-.92,1.6-.92,2.69v6.74h-1.89v-11.81h1.89v1.96h.05c.89-1.49,2.18-2.24,3.88-2.24,1.29,0,2.28.42,2.96,1.26.68.83,1.03,2.03,1.03,3.61v7.22Zm9.07-.12c-.45.25-1.03.37-1.76.37-2.07,0-3.1-1.15-3.1-3.46v-6.99h-2.03v-1.61h2.03v-2.88l1.89-.61v3.49h2.98v1.61h-2.98v6.66c0,.79.13,1.36.4,1.7.27.34.72.51,1.34.51.48,0,.89-.13,1.23-.39v1.61Zm8.71-9.78c-.33-.25-.81-.38-1.43-.38-.81,0-1.48.38-2.03,1.14-.54.76-.81,1.8-.81,3.11v6.02h-1.89v-11.81h1.89v2.43h.05c.27-.83.68-1.48,1.23-1.94.55-.47,1.17-.7,1.86-.7.49,0,.87.05,1.13.16v1.96Zm11.48-1.91l-5.43,13.7c-.97,2.45-2.33,3.67-4.08,3.67-.49,0-.9-.05-1.23-.15v-1.7c.41.14.78.21,1.12.21.95,0,1.67-.57,2.15-1.71l.95-2.24-4.61-11.79h2.1l3.2,9.09c.04.12.12.42.24.9h.07c.04-.18.12-.48.23-.88l3.36-9.11h1.96Z" />
				<path d="m640.02,221.72v-16.54h4.71c1.43,0,2.56.35,3.4,1.05s1.26,1.61,1.26,2.73c0,.94-.25,1.75-.76,2.45-.51.69-1.21,1.18-2.1,1.48v.05c1.12.13,2.01.55,2.68,1.27.67.71,1,1.63,1,2.77,0,1.41-.51,2.56-1.52,3.44-1.02.88-2.3,1.31-3.84,1.31h-4.82Zm1.94-14.79v5.34h1.98c1.06,0,1.9-.25,2.5-.76.61-.52.91-1.24.91-2.17,0-1.61-1.06-2.41-3.17-2.41h-2.23Zm0,7.08v5.95h2.63c1.14,0,2.02-.27,2.64-.81.63-.54.95-1.28.95-2.21,0-1.95-1.33-2.93-3.99-2.93h-2.23Zm20.82,2.27h-8.34c.03,1.31.38,2.33,1.06,3.05.68.72,1.61,1.07,2.79,1.07,1.33,0,2.55-.44,3.67-1.31v1.78c-1.04.75-2.41,1.13-4.12,1.13s-2.98-.53-3.93-1.6c-.95-1.08-1.43-2.59-1.43-4.53,0-1.84.52-3.33,1.56-4.49,1.05-1.16,2.34-1.74,3.89-1.74s2.74.5,3.59,1.5c.85,1,1.27,2.39,1.27,4.16v.99Zm-1.94-1.6c0-1.09-.27-1.94-.8-2.55-.52-.61-1.23-.91-2.16-.91s-1.65.32-2.27.96c-.62.64-1.01,1.47-1.15,2.5h6.38Zm14.86,7.04h-1.89v-2.01h-.05c-.88,1.52-2.23,2.28-4.06,2.28-1.48,0-2.67-.53-3.56-1.58-.88-1.06-1.33-2.5-1.33-4.33,0-1.95.49-3.52,1.48-4.69.98-1.18,2.3-1.76,3.93-1.76s2.8.64,3.54,1.91h.05v-7.31h1.89v17.49Zm-1.89-5.34v-1.74c0-.95-.32-1.76-.95-2.42-.63-.66-1.43-.99-2.4-.99-1.15,0-2.06.42-2.72,1.27-.66.85-.99,2.01-.99,3.51,0,1.36.32,2.44.95,3.23.64.78,1.49,1.18,2.56,1.18s1.91-.38,2.56-1.14c.66-.76.99-1.72.99-2.88Zm11.87-4.56c-.33-.25-.81-.38-1.43-.38-.81,0-1.48.38-2.03,1.14-.54.76-.81,1.8-.81,3.11v6.02h-1.89v-11.81h1.89v2.43h.05c.27-.83.68-1.48,1.23-1.94.55-.47,1.17-.7,1.86-.7.49,0,.87.05,1.13.16v1.96Zm6.98,10.17c-1.75,0-3.14-.55-4.19-1.65-1.04-1.11-1.56-2.57-1.56-4.39,0-1.98.54-3.53,1.63-4.65,1.08-1.11,2.55-1.67,4.39-1.67s3.13.54,4.12,1.63c.99,1.08,1.49,2.59,1.49,4.51s-.53,3.39-1.6,4.53c-1.06,1.13-2.49,1.7-4.28,1.7Zm.14-10.77c-1.21,0-2.18.42-2.88,1.25-.71.82-1.06,1.96-1.06,3.41s.36,2.5,1.07,3.31c.72.81,1.67,1.21,2.87,1.21s2.16-.4,2.81-1.19c.66-.79.99-1.92.99-3.38s-.33-2.61-.99-3.41c-.65-.8-1.59-1.2-2.81-1.2Zm13.69,10.77c-1.75,0-3.14-.55-4.19-1.65-1.04-1.11-1.56-2.57-1.56-4.39,0-1.98.54-3.53,1.63-4.65,1.08-1.11,2.55-1.67,4.39-1.67s3.13.54,4.12,1.63c.99,1.08,1.49,2.59,1.49,4.51s-.53,3.39-1.6,4.53c-1.06,1.13-2.49,1.7-4.28,1.7Zm.14-10.77c-1.21,0-2.18.42-2.88,1.25-.71.82-1.06,1.96-1.06,3.41s.36,2.5,1.07,3.31c.72.81,1.67,1.21,2.87,1.21s2.16-.4,2.81-1.19c.66-.79.99-1.92.99-3.38s-.33-2.61-.99-3.41c-.65-.8-1.59-1.2-2.81-1.2Zm25.52,10.5h-1.89v-6.78c0-1.31-.2-2.25-.61-2.84-.4-.58-1.08-.88-2.03-.88-.81,0-1.5.37-2.06,1.11-.56.74-.84,1.62-.84,2.65v6.74h-1.89v-7.01c0-2.32-.9-3.48-2.69-3.48-.83,0-1.51.35-2.05,1.05-.54.69-.81,1.6-.81,2.71v6.74h-1.89v-11.81h1.89v1.87h.05c.84-1.43,2.06-2.15,3.67-2.15.81,0,1.51.23,2.11.68.6.45,1.01,1.03,1.23,1.76.88-1.63,2.18-2.45,3.92-2.45,2.6,0,3.9,1.6,3.9,4.81v7.28Z" />
				<path d="m651.75,239.51c0,1.1-.11,2.08-.33,2.95-.22.86-.54,1.58-.96,2.18-.42.59-.93,1.05-1.54,1.36-.6.31-1.29.46-2.07.46s-1.49-.14-2.1-.42v-1.32c.67.37,1.38.56,2.13.56.54,0,1.03-.11,1.45-.34.43-.22.79-.55,1.09-.97.3-.43.52-.96.68-1.59.16-.63.24-1.35.24-2.16h-.03c-.51,1.04-1.41,1.55-2.69,1.55-.51,0-.99-.09-1.42-.27-.43-.18-.8-.44-1.12-.77-.31-.34-.56-.73-.73-1.19-.17-.46-.26-.97-.26-1.52,0-.59.1-1.14.29-1.63.2-.49.46-.92.81-1.27.35-.36.76-.64,1.23-.83.48-.2.99-.29,1.55-.29.6,0,1.14.12,1.6.37.47.24.86.6,1.18,1.07.32.46.56,1.04.73,1.72.17.68.25,1.46.25,2.34Zm-1.49-1.23c0-.46-.06-.89-.18-1.27-.12-.38-.28-.71-.5-.97-.21-.27-.47-.48-.76-.63-.29-.15-.61-.23-.96-.23s-.64.07-.92.2c-.29.13-.53.31-.75.55-.21.24-.37.52-.5.85-.12.32-.18.68-.18,1.07,0,.43.06.81.17,1.14.12.34.28.62.5.86.21.23.47.41.76.53.3.12.64.18,1,.18.32,0,.62-.06.9-.18.29-.12.53-.29.74-.49.21-.21.38-.45.5-.72.12-.28.18-.58.18-.9Z" />
				<rect x="653.96" y="234.21" width="1.22" height="3.75" />
				<path d="m664.97,235.01c-.18.32-.41.72-.67,1.19-.26.48-.53,1.01-.82,1.6s-.59,1.23-.89,1.91c-.3.68-.58,1.39-.85,2.12-.26.73-.5,1.47-.7,2.22-.2.74-.34,1.48-.43,2.2h-1.48c.1-.72.25-1.45.46-2.19.21-.75.45-1.48.71-2.2.27-.72.55-1.42.85-2.08.3-.67.58-1.28.86-1.84.28-.56.53-1.05.76-1.48.24-.43.42-.77.56-1.01h-6.04v-1.24h7.66v.8Z" />
				<path d="m668.36,234.21v3.75h-1.22v-3.75h1.22Zm2.79,0v3.75h-1.22v-3.75h1.22Z" />
				<path d="m684.9,237.65l-2.89,4.35,2.84,4.25h-1.6l-1.69-2.79c-.11-.17-.23-.39-.38-.65h-.03c-.03.05-.16.27-.39.65l-1.72,2.79h-1.59l2.93-4.21-2.8-4.38h1.6l1.66,2.94c.12.22.24.44.36.67h.03l2.15-3.61h1.52Z" />
				<path d="m695.91,246.25h-1.38v-10.4c-.11.11-.26.23-.47.37-.2.13-.43.27-.69.4-.25.13-.52.26-.81.38-.28.12-.55.21-.82.28v-1.39c.3-.08.62-.2.96-.34.34-.15.67-.31,1-.48.33-.18.64-.36.93-.55.29-.2.54-.39.76-.57h.52v12.31Zm9.28,0h-1.38v-10.4c-.11.11-.26.23-.47.37-.2.13-.43.27-.69.4-.25.13-.52.26-.81.38-.28.12-.55.21-.82.28v-1.39c.3-.08.62-.2.96-.34.34-.15.67-.31,1-.48.33-.18.64-.36.93-.55.29-.2.54-.39.76-.57h.52v12.31Z" />
				<rect x="709.76" y="234.21" width="1.22" height="3.75" />
				<path d="m719.42,234.21v7.95h1.54v1.26h-1.54v2.83h-1.36v-2.83h-5.66v-1.19c.53-.59,1.06-1.23,1.59-1.9.54-.68,1.05-1.36,1.54-2.06.49-.69.95-1.39,1.36-2.07.42-.69.77-1.36,1.06-1.99h1.47Zm-5.47,7.95h4.11v-5.89c-.42.73-.82,1.39-1.19,1.96-.38.58-.73,1.1-1.07,1.57-.34.47-.66.9-.97,1.28-.31.38-.6.74-.87,1.08Z" />
				<path d="m724.15,234.21v3.75h-1.22v-3.75h1.22Zm2.79,0v3.75h-1.22v-3.75h1.22Z" />
				<path d="m332.55,616.88h-2.7l-6.39-7.57c-.24-.28-.38-.48-.44-.58h-.05v8.14h-1.94v-16.54h1.94v7.77h.05c.11-.17.25-.36.44-.57l6.18-7.21h2.41l-7.09,7.94,7.59,8.6Zm2.89-14.81c-.34,0-.63-.12-.87-.35-.24-.23-.36-.52-.36-.88s.12-.65.36-.88c.24-.24.53-.36.87-.36s.64.12.88.36c.25.23.37.52.37.88s-.12.63-.37.87c-.24.24-.53.36-.88.36Zm.92,14.81h-1.89v-11.81h1.89v11.81Zm9.29-.12c-.45.25-1.03.37-1.76.37-2.07,0-3.1-1.15-3.1-3.46v-6.99h-2.03v-1.61h2.03v-2.88l1.89-.61v3.49h2.98v1.61h-2.98v6.66c0,.79.13,1.36.4,1.7.27.34.72.51,1.34.51.48,0,.89-.13,1.23-.39v1.61Zm10.57-.43c-.91.55-1.98.82-3.23.82-1.68,0-3.05-.55-4.08-1.64-1.03-1.1-1.55-2.52-1.55-4.27,0-1.95.56-3.51,1.67-4.68,1.11-1.18,2.6-1.78,4.46-1.78,1.04,0,1.95.19,2.75.58v1.94c-.88-.62-1.81-.92-2.81-.92-1.21,0-2.2.43-2.98,1.3-.77.86-1.15,2-1.15,3.4s.36,2.48,1.08,3.28c.73.8,1.71,1.2,2.93,1.2,1.03,0,2-.34,2.91-1.03v1.8Zm12.65.54h-1.89v-6.81c0-2.46-.92-3.69-2.75-3.69-.92,0-1.7.36-2.33,1.07-.63.71-.95,1.62-.95,2.73v6.69h-1.89v-17.49h1.89v7.64h.05c.91-1.49,2.2-2.24,3.88-2.24,2.66,0,3.99,1.6,3.99,4.81v7.28Zm13.05-5.43h-8.34c.03,1.31.38,2.33,1.06,3.05.68.72,1.61,1.07,2.79,1.07,1.33,0,2.55-.44,3.67-1.31v1.78c-1.04.75-2.41,1.13-4.12,1.13s-2.98-.53-3.93-1.6c-.95-1.08-1.43-2.59-1.43-4.53,0-1.84.52-3.33,1.56-4.49,1.05-1.16,2.34-1.74,3.89-1.74s2.74.5,3.59,1.5c.85,1,1.27,2.39,1.27,4.16v.99Zm-1.94-1.6c0-1.09-.27-1.94-.8-2.55-.52-.61-1.23-.91-2.16-.91s-1.65.32-2.27.96c-.62.64-1.01,1.47-1.15,2.5h6.38Zm14.59,7.04h-1.89v-6.74c0-2.51-.92-3.76-2.75-3.76-.95,0-1.73.36-2.35,1.07-.62.71-.92,1.6-.92,2.69v6.74h-1.89v-11.81h1.89v1.96h.05c.89-1.49,2.18-2.24,3.88-2.24,1.29,0,2.28.42,2.96,1.26.68.83,1.03,2.03,1.03,3.61v7.22Z" />
				<path d="m308.67,258.25h-8.58v-16.54h1.94v14.79h6.64v1.75Zm3.25-14.81c-.34,0-.63-.12-.87-.35s-.36-.52-.36-.88.12-.65.36-.88c.24-.24.53-.36.87-.36s.64.12.88.36c.25.23.37.52.37.88s-.12.63-.37.87c-.24.24-.53.36-.88.36Zm.92,14.81h-1.89v-11.81h1.89v11.81Zm13.1-11.81l-4.71,11.81h-1.86l-4.48-11.81h2.08l3,8.58c.22.63.36,1.18.42,1.65h.05c.08-.59.2-1.13.37-1.6l3.14-8.63h2Zm2.99-3c-.34,0-.63-.12-.87-.35-.24-.23-.36-.52-.36-.88s.12-.65.36-.88c.24-.24.53-.36.87-.36s.64.12.88.36c.25.23.37.52.37.88s-.12.63-.37.87c-.24.24-.53.36-.88.36Zm.92,14.81h-1.89v-11.81h1.89v11.81Zm13.62,0h-1.89v-6.74c0-2.51-.92-3.76-2.75-3.76-.95,0-1.73.36-2.35,1.07-.62.71-.92,1.6-.92,2.69v6.74h-1.89v-11.81h1.89v1.96h.05c.89-1.49,2.18-2.24,3.88-2.24,1.29,0,2.28.42,2.96,1.26.68.83,1.03,2.03,1.03,3.61v7.22Zm13.64-.95c0,4.34-2.08,6.51-6.23,6.51-1.46,0-2.74-.28-3.83-.83v-1.89c1.33.74,2.6,1.11,3.81,1.11,2.91,0,4.36-1.55,4.36-4.64v-1.29h-.05c-.9,1.51-2.25,2.26-4.06,2.26-1.47,0-2.65-.52-3.55-1.57-.89-1.05-1.34-2.46-1.34-4.23,0-2.01.48-3.6,1.44-4.79.97-1.18,2.29-1.78,3.97-1.78s2.77.64,3.54,1.91h.05v-1.64h1.89v10.87Zm-1.89-4.39v-1.74c0-.94-.32-1.74-.96-2.41-.63-.67-1.42-1-2.36-1-1.17,0-2.08.43-2.75,1.28-.66.85-.99,2.03-.99,3.56,0,1.31.32,2.37.95,3.16.64.78,1.48,1.18,2.53,1.18s1.92-.38,2.58-1.13c.67-.75,1-1.72,1-2.9Z" />
				<polygon points="368.42 241.71 360.48 260.99 358.72 260.99 366.63 241.71 368.42 241.71" />
				<path d="m370.34,258.25v-16.54h4.57c5.83,0,8.74,2.69,8.74,8.06,0,2.55-.81,4.61-2.43,6.16-1.61,1.55-3.78,2.32-6.49,2.32h-4.38Zm1.94-14.79v13.03h2.47c2.17,0,3.86-.58,5.06-1.74,1.21-1.16,1.81-2.81,1.81-4.94,0-4.24-2.25-6.36-6.76-6.36h-2.58Zm15.27-.02c-.34,0-.63-.12-.87-.35-.24-.23-.36-.52-.36-.88s.12-.65.36-.88c.24-.24.53-.36.87-.36s.64.12.88.36c.25.23.37.52.37.88s-.12.63-.37.87c-.24.24-.53.36-.88.36Zm.92,14.81h-1.89v-11.81h1.89v11.81Zm13.56,0h-1.89v-6.74c0-2.51-.92-3.76-2.75-3.76-.95,0-1.73.36-2.35,1.07-.62.71-.92,1.6-.92,2.69v6.74h-1.89v-11.81h1.89v1.96h.05c.89-1.49,2.18-2.24,3.88-2.24,1.29,0,2.28.42,2.96,1.26.68.83,1.03,2.03,1.03,3.61v7.22Zm4.47-14.81c-.34,0-.63-.12-.87-.35-.24-.23-.36-.52-.36-.88s.12-.65.36-.88c.24-.24.53-.36.87-.36s.64.12.88.36c.25.23.37.52.37.88s-.12.63-.37.87c-.24.24-.53.36-.88.36Zm.92,14.81h-1.89v-11.81h1.89v11.81Zm13.56,0h-1.89v-6.74c0-2.51-.92-3.76-2.75-3.76-.95,0-1.73.36-2.35,1.07-.62.71-.92,1.6-.92,2.69v6.74h-1.89v-11.81h1.89v1.96h.05c.89-1.49,2.18-2.24,3.88-2.24,1.29,0,2.28.42,2.96,1.26.68.83,1.03,2.03,1.03,3.61v7.22Zm13.58-.95c0,4.34-2.08,6.51-6.23,6.51-1.46,0-2.74-.28-3.83-.83v-1.89c1.33.74,2.6,1.11,3.81,1.11,2.91,0,4.36-1.55,4.36-4.64v-1.29h-.05c-.9,1.51-2.25,2.26-4.06,2.26-1.47,0-2.65-.52-3.55-1.57-.89-1.05-1.34-2.46-1.34-4.23,0-2.01.48-3.6,1.44-4.79.97-1.18,2.29-1.78,3.97-1.78s2.77.64,3.54,1.91h.05v-1.64h1.89v10.87Zm-1.89-4.39v-1.74c0-.94-.32-1.74-.96-2.41-.63-.67-1.42-1-2.36-1-1.17,0-2.08.43-2.75,1.28-.66.85-.99,2.03-.99,3.56,0,1.31.32,2.37.95,3.16.64.78,1.48,1.18,2.53,1.18s1.92-.38,2.58-1.13c.67-.75,1-1.72,1-2.9Z" />
				<path d="m457.18,258.25h-2.31l-2.77-4.64c-.25-.43-.5-.8-.74-1.1-.24-.31-.48-.56-.74-.75-.25-.19-.52-.33-.81-.42-.28-.09-.61-.14-.97-.14h-1.59v7.04h-1.94v-16.54h4.94c.72,0,1.39.09,2,.28.62.18,1.15.45,1.59.82.45.37.81.83,1.06,1.38.25.55.38,1.19.38,1.93,0,.58-.09,1.11-.27,1.59-.17.48-.42.9-.74,1.28-.32.38-.7.7-1.15.97-.45.26-.95.47-1.51.61v.05c.28.12.52.27.72.43.21.15.4.34.59.55.18.22.37.46.54.74.18.27.39.58.61.95l3.1,4.97Zm-9.92-14.79v6h2.63c.48,0,.93-.07,1.34-.22.42-.15.77-.35,1.07-.62.3-.28.53-.61.7-1,.17-.4.25-.85.25-1.34,0-.88-.29-1.57-.87-2.06-.57-.5-1.4-.75-2.48-.75h-2.65Zm16.8,15.06c-1.75,0-3.14-.55-4.19-1.65-1.04-1.11-1.56-2.57-1.56-4.39,0-1.98.54-3.53,1.63-4.65,1.08-1.11,2.55-1.67,4.39-1.67s3.13.54,4.12,1.63c.99,1.08,1.49,2.59,1.49,4.51s-.53,3.39-1.6,4.53c-1.06,1.13-2.49,1.7-4.28,1.7Zm.14-10.77c-1.21,0-2.18.42-2.88,1.25-.71.82-1.06,1.96-1.06,3.41s.36,2.5,1.07,3.31c.72.81,1.67,1.21,2.87,1.21s2.16-.4,2.81-1.19c.66-.79.99-1.92.99-3.38s-.33-2.61-.99-3.41c-.65-.8-1.59-1.2-2.81-1.2Zm13.64,10.77c-1.75,0-3.14-.55-4.19-1.65-1.04-1.11-1.56-2.57-1.56-4.39,0-1.98.54-3.53,1.63-4.65,1.08-1.11,2.55-1.67,4.39-1.67s3.13.54,4.12,1.63c.99,1.08,1.49,2.59,1.49,4.51s-.53,3.39-1.6,4.53c-1.06,1.13-2.49,1.7-4.28,1.7Zm.14-10.77c-1.21,0-2.18.42-2.88,1.25-.71.82-1.06,1.96-1.06,3.41s.36,2.5,1.07,3.31c.72.81,1.67,1.21,2.87,1.21s2.16-.4,2.81-1.19c.66-.79.99-1.92.99-3.38s-.33-2.61-.99-3.41c-.65-.8-1.59-1.2-2.81-1.2Zm25.47,10.5h-1.89v-6.78c0-1.31-.2-2.25-.61-2.84-.4-.58-1.08-.88-2.03-.88-.81,0-1.5.37-2.06,1.11-.56.74-.84,1.62-.84,2.65v6.74h-1.89v-7.01c0-2.32-.9-3.48-2.69-3.48-.83,0-1.51.35-2.05,1.05-.54.69-.81,1.6-.81,2.71v6.74h-1.89v-11.81h1.89v1.87h.05c.84-1.43,2.06-2.15,3.67-2.15.81,0,1.51.23,2.11.68.6.45,1.01,1.03,1.23,1.76.88-1.63,2.18-2.45,3.92-2.45,2.6,0,3.9,1.6,3.9,4.81v7.28Z" />
				<path d="m360.27,282.77h-1.38v-10.4c-.11.11-.26.23-.47.37-.2.13-.43.27-.69.4-.25.13-.52.26-.81.38-.28.12-.55.21-.82.28v-1.39c.3-.08.62-.2.96-.34.34-.15.67-.31,1-.48.33-.18.64-.36.93-.55.29-.2.54-.39.76-.57h.52v12.31Zm11.76-6.07c0,1.01-.09,1.9-.28,2.68-.18.78-.44,1.44-.79,1.97-.34.53-.76.94-1.27,1.22-.5.27-1.07.41-1.7.41-.6,0-1.14-.13-1.62-.39-.47-.27-.87-.66-1.19-1.17-.32-.51-.57-1.13-.74-1.87-.17-.74-.25-1.6-.25-2.55,0-1.05.09-1.98.26-2.79.18-.81.44-1.48.78-2.02.34-.55.76-.96,1.27-1.23.51-.28,1.09-.42,1.75-.42,2.52,0,3.79,2.06,3.79,6.17Zm-1.41.13c0-3.43-.81-5.14-2.44-5.14-1.72,0-2.58,1.74-2.58,5.23,0,3.25.84,4.88,2.53,4.88s2.49-1.66,2.49-4.97Z" />
				<rect x="374.12" y="270.73" width="1.22" height="3.75" />
				<path d="m383.78,270.73v7.95h1.54v1.26h-1.54v2.83h-1.36v-2.83h-5.66v-1.19c.53-.59,1.06-1.23,1.6-1.9.54-.68,1.05-1.36,1.54-2.06.49-.69.95-1.39,1.36-2.07.42-.69.77-1.36,1.06-1.99h1.47Zm-5.47,7.95h4.11v-5.89c-.42.73-.82,1.39-1.19,1.96-.37.58-.73,1.1-1.07,1.57-.34.47-.66.9-.97,1.28-.31.38-.6.74-.87,1.08Z" />
				<path d="m388.51,270.73v3.75h-1.22v-3.75h1.22Zm2.79,0v3.75h-1.22v-3.75h1.22Z" />
				<path d="m405.05,274.18l-2.89,4.35,2.84,4.25h-1.6l-1.69-2.79c-.11-.17-.23-.39-.38-.65h-.03c-.03.05-.16.27-.39.65l-1.72,2.79h-1.59l2.93-4.21-2.8-4.38h1.6l1.66,2.94c.12.22.24.44.36.67h.03l2.15-3.61h1.52Z" />
				<path d="m416.06,282.77h-1.38v-10.4c-.11.11-.26.23-.47.37-.2.13-.43.27-.69.4-.25.13-.52.26-.81.38-.28.12-.55.21-.82.28v-1.39c.3-.08.62-.2.96-.34.34-.15.67-.31,1-.48.33-.18.64-.36.93-.55.29-.2.54-.39.76-.57h.52v12.31Zm11.2-3.41c0,.54-.1,1.04-.31,1.49-.2.44-.49.82-.86,1.14-.37.31-.81.56-1.33.73-.52.17-1.09.26-1.72.26-1.15,0-2.06-.22-2.74-.65v-1.48c.81.64,1.74.96,2.79.96.42,0,.8-.05,1.13-.16.34-.11.63-.26.87-.46.25-.2.43-.45.56-.73.13-.29.2-.61.2-.97,0-1.57-1.12-2.36-3.36-2.36h-1v-1.17h.95c1.98,0,2.97-.74,2.97-2.22,0-1.37-.76-2.05-2.27-2.05-.85,0-1.65.29-2.39.86v-1.33c.77-.46,1.68-.69,2.74-.69.5,0,.96.07,1.37.21s.76.34,1.05.59.51.55.67.91c.16.35.24.74.24,1.17,0,1.58-.8,2.6-2.4,3.06v.03c.41.04.79.15,1.13.3.35.15.65.35.9.6.25.25.45.54.59.87.15.33.22.7.22,1.1Z" />
				<rect x="429.91" y="270.73" width="1.22" height="3.75" />
				<path d="m441,276.7c0,1.01-.09,1.9-.28,2.68-.18.78-.44,1.44-.79,1.97-.34.53-.76.94-1.27,1.22-.5.27-1.07.41-1.7.41-.6,0-1.14-.13-1.62-.39-.47-.27-.87-.66-1.19-1.17-.32-.51-.57-1.13-.74-1.87-.17-.74-.25-1.6-.25-2.55,0-1.05.09-1.98.26-2.79.18-.81.44-1.48.78-2.02.34-.55.76-.96,1.27-1.23.51-.28,1.09-.42,1.75-.42,2.52,0,3.79,2.06,3.79,6.17Zm-1.41.13c0-3.43-.81-5.14-2.44-5.14-1.72,0-2.58,1.74-2.58,5.23,0,3.25.84,4.88,2.53,4.88s2.49-1.66,2.49-4.97Z" />
				<path d="m444.3,270.73v3.75h-1.22v-3.75h1.22Zm2.79,0v3.75h-1.22v-3.75h1.22Z" />
				<path d="m558.08,637.58l-2.72,9.63h-1.32l-1.98-7.04c-.09-.3-.14-.63-.15-.98h-.03c-.03.33-.09.65-.17.97l-1.99,7.05h-1.31l-2.82-9.63h1.24l2.05,7.39c.09.31.14.63.16.97h.03c.02-.24.09-.56.21-.97l2.13-7.39h1.08l2.04,7.44c.07.26.13.56.16.9h.03c.02-.23.08-.54.18-.93l1.97-7.41h1.22Z" />
				<polygon points="563.7 637.58 559.08 648.81 558.06 648.81 562.66 637.58 563.7 637.58" />
				<path d="m564.83,647.21v-9.63h2.66c3.39,0,5.09,1.56,5.09,4.69,0,1.49-.47,2.68-1.42,3.59-.94.9-2.2,1.35-3.78,1.35h-2.55Zm1.13-8.61v7.59h1.44c1.26,0,2.25-.34,2.95-1.01.7-.68,1.05-1.63,1.05-2.87,0-2.47-1.31-3.7-3.94-3.7h-1.5Z" />
			</g>
		</g>
	)
}

export default PlanEE
